export default {
    "id": "ID",
    "dashboard": "Daashboordii",
    "warning": "Akeekkachiisa",
    "users": "Fayyadamtoota",
    "farms": "Qonna",
    "animals": "Bineensota",
    "action": "Gocha",
    "actionList": "Tarree Tarkaanfii",
    "drugInventory": "Inventarii Qorichaa",
    "inseminatorStatistics": "Istaatistiksii Inseminaator",
    "organizationNTR": "Dhaabbata NTR",
    "genotypePerformance": "Raawwii Hojii Jeenootaayipii",
    "semenAutomation": "Semen Automation gochuu",
    "activityLogs": "Galmee Gochaalee",
    "username": "Maqaa Fayyadamtootaa",
    "title": "Mata-duree",
    "deactivated": "Deactivated ta'eera",
    "name": "Maqaa",
    "email": "Imeelii",
    "emailAddress": "Teessoo Imeelii",
    "mobileNum": "Lakkoofsa Mobaayilaa",
    "emailOrMobile": "Imeelii/Mobaayila",
    "role": "Ga'ee",
    "roles": "Gahee hojii",
    "department": "Qajeelcha",
    "status": "Sadarkaa",
    "pages": "Fuula",
    "departments": "Kutaalee hojii",
    "password": "Jecha iccitii",
    "cancel": "Haquu",
    "submit": "Galchuu",
    "error": "dogoggora",
    "success": "milkaa'ina",
    "Browse": "Daawwadhu",
    "orDropYourFileCsvXlsXlsxHere": "ykn faayilii kee (CSV, XLS, XLSx) asitti gadi dhiisi",
    "search": "Barbaaduu",
    "apply": "Hojiirra oolchuu",
    "select": "Filuu",
    "previous": "Kan duraa",
    "mandatory": "Dirqama",
    "dropYourFileHere": "ykn faayilii keessan (CSV, XLS, XLSx, PDF,Docx,PNG,JPEG) asitti gadi dhiisaa",
    "restoreDefault": "Durtii Deebisuu",
    "pending": "Eeggataa kan jiru",
    "completed": "Xumurameera",
    "remove": "Irraa kaasuu",
    "update": "Odeeffannoo dhiyeenyaa",
    "removeFile": "Faayila Haquu",
    "uploadFile": "Faayila Olkaa'uu",
    "pleaseChoosePreferedLanguage": "Mee afaan filattan filadhaa",
    "edit": "Gulaaluu",
    "activate": "Hojiirra oolchi",
    "deactivate": "Deactivate gochuu",
    "recievedOrders": "Ajaja Argame",
    "chartRepresentation": "Bakka Bu’iinsa Chaartii",
    "nameIsRequired": "Maqaa barbaachisa",
    "export": "Alergii",
    "noFilesAvailable": "FAAYILII HIN JIRU",
    "selectDepartmentToshowRoles": "Kutaa gahee hojii agarsiisu filadhu",
    "selectDepartmentWithActiveRoles": "Kutaa gahee hojii sochii qabu filadhu",
    "nameCanContainOnlyAlphabets": "Maqaan qubee qofa qabachuu danda'a",
    "nameMustBeLessThan15Chars": "Maqaan arfiilee 30 gadi ta'uu qaba",
    "emailRequired": "Email barbaachisa",
    "invalidEmailFormat": "Akkaataa Imeelii Sirrii Hin Taane",
    "mobNumReq": "Lakkoofsi moobaayilaa barbaachisa",
    "invalidMobFormat": "Akkaataa lakkoofsa moobaayilaa sirrii hin taane.",
    "passwordRequired": "Password barbaachisa",
    "departmentReq": "Kutaan barbaachisaadha",
    "roleReq": "Gaheen barbaachisaadha",
    "unableToUpdate": "Haaromsuu hin dandeenye",
    "orignalName": "Maqaa Jalqabaa",
    "uploadedDate": "Guyyaa Olkaa'ame",
    "fileName": "Maqaa Faayilii",
    "importNum": "Lakkoofsa Galchuu",
    "languagePreferences": "Filannoo Afaanii",
    "pleaseTryAgainAfterSometime": "Mee yeroo tokko booda yaalaa",
    "noChanges": "Jijjiiramni Hin Jiru",
    "nothingchanged": "Wanti Jijjiirame Hin Jiru",
    "pleaseChooseAnImageFile": "Mee faayilii fakkii filadhu",
    "fileIsTooBigSelectUnder1MB": "Faayilli kee baay'ee guddaadha! ",
    "phoneShouldHave10Chars": "Bilbilli qubee 10 qabaachuu qaba",
    "onlyCSVAllowed": "Faayilii CSV qofatu hayyamama",
    "loadingPleaseWait": "Loading... Mee eegaa",
    "manager": "hoji-geggeessaa",
    "administrator": "bulchaa",
    "Comingsoon": "Yeroo dhiyootti",
    "totalAnimals": "Waliigala Bineensota",
    "receivedOrders": "Ajaja Fudhatame",
    "drugs": "Qoricha sammuu hadoochu",
    "detailedAnalysis": "Xiinxala Bal’aa",
    "barGraphRepOfActiveUsersAndDeactivateUsers": "Bakka Bu'iinsa Bar Giraafii Fayyadamtoota Socho'oo fi Fayyadamtoota Socho'oo",
    "barGraphRepOfRegAnimalsVsFarm": "Bakka Bu’iinsa Bar Giraafii Beeylada Galmaa’e Vs Qonna",
    "roleNumber": "Lakkoofsa Gahee",
    "roleName": "Maqaa Gahee Hojii",
    "active": "Si'aawaa",
    "inactive": "InActive",
    "admin": "Admin",
    "addRole": "Gahee Dabaluu",
    "addRoles": "Gahee Dabaluu",
    "permissions": "Hayyama",
    "sr": "Sr.",
    "moduleName": "Maqaa Moojulii",
    "view": "Ilaaluu",
    "deptNo": "Kutaa Lakk.",
    "selectByCategory": "Ramaddiitiin filadhu",
    "weeklyAnalytics": "Xiinxala Torbanii",
    "pregnancy": "Ulfa",
    "analytics": "Xiinxala",
    "calendar": "Kaalaandarii",
    "productName": "Maqaa Omishaa",
    "volumeSold": "Jildii Gurgurame",
    "recordPoints": "Qabxiilee Galmeessuu",
    "inStock": "In Stock keessa jira",
    "revenue": "Galii",
    "stockStatus": "Haala Istookii",
    "barChart": "Chaartii Bar",
    "lineChart": "Chaartii Sararaa",
    "indexReturns": "Deebi'aa Indeeksii",
    "chart": "Fakkii",
    "time": "yeroo",
    "production": "Oomisha",
    "customization": "Akkaataa barbaadetti jijjiiruu",
    "recordsPerPage": "Galmee Fuula tokko irratti",
    "noDataAvailable": "Daataan Hin Argamu",
    "reporting": "Gabaasa",
    "optional": "Dirqama kan hinta'in",
    "note": "Yaadannoo",
    "notes": "Hubachiisa",
    "date": "Guyyaa",
    "kG": "KG",
    "weight": "ulfaatina",
    "type": "Akaakuu",
    "lessthan3Month": "<Ji'a 3",
    "lessthan6Month": "<Ji'a 6",
    "lessthan7Month": "<Ji'a 7",
    "lastWeek": "Torbee darbe",
    "thisWeek": "Torban Kana",
    "lessthanOneYear": "<Waggaa 1",
    "lessthanTwoYear": "<Waggaa 2",
    "lessthanThreeYear": "<Waggaa 3",
    "lessthanFourYear": "<Waggaa 4",
    "yes": "Eeyyee",
    "no": "Lakki",
    "of": "kan",
    "notSpecified": "Hin Ibsamne",
    "days": "guyyoota",
    "day": "guyyaa",
    "aDay": "guyyaa tokkotti",
    "years": "waggoota",
    "year": "waggaa",
    "unit": "safartuu",
    "units": "Yuunitii",
    "to": "gara",
    "profile": "Ibsama",
    "logOut": "Ba'i",
    "Unit": "Safartuu",
    "otherSettings": "Sajoo Biroo",
    "somethingWentWrong": "wanti tokko dogoggora ta’e.",
    "toDo": "Hojjechuuf",
    "loadingData": "Daataa Fe'aa Jira...",
    "taskNumber": "Lakkoofsa Hojii",
    "taskName": "Maqaa Hojii",
    "startDate": "Guyyaa Jalqabaa",
    "dueDate": "Guyyaa Guutuu",
    "reason": "Sababa",
    "quantity": "Baay'ina",
    "cost": "Baasii",
    "noRecordFound": "Galmeen Hin Argamne",
    "dailyUpdates": "Oduu Guyyaa Guyyaa",
    "weeklyUpdates": "Torban Torbanitti Odeeffannoo Haaraa",
    "moduleAccessed": "Moojulii Argame",
    "typesOfAccess": "Gosoota Dhaqqabummaa",
    "userId": "UserId",
    "lastLogin": "Galmee Dhumaa",
    "terminalID": "ID Tarminaala",
    "geographicalAccessPoint": "Qabxii Dhaqqabummaa Teessuma Lafaa",
    "iPAddress": "Teessoo IP",
    "fileAccessed": "Faayilii Argame",
    "functionAccessed": "Faankishinii Argame",
    "webPageURL": "URL Fuula Weebsaayitii",
    "accessType": "Gosa Dhaqqabummaa",
    "unsuccessfulLoginAttempts": "Yaalii Galchuu Hin Milkaa'in",
    "customerAddress": "Teessoo Maamilaa",
    "orderdate": "Guyyaa Ajaja",
    "postageDate": "Guyyaa Poostaa",
    "postID": "ID Poostaa",
    "packingTechnician": "Teeknishaana Paakkii",
    "packingTechnicia": "Teeknishaa Paakkii",
    "packEdit": "Gulaaluun Paakkii",
    "batchNumber": "Lakkoofsa Batch",
    "collectionTechnician": "Teeknishaana Walitti Qabuu",
    "collectionTechnicia": "Teeknishaa Walitti Qabuu",
    "preparationTechnicia": "Teeknishaa Qophii",
    "preparationTechnician": "Teeknishaan Qophii",
    "approvedManually": "Harkaan Raggaasifame",
    "researcher": "Qorataa",
    "dateOfApproval": "Guyyaa Raggaasifamuu",
    "approvalEdit": "Raggaasisuu Gulaaluu",
    "searchByAllExceptDate": "Guyyaa Malee Hundaan Barbaadi",
    "approval": "Mirkaneessa",
    "collection": "Walitti qabama",
    "postage": "Poostaa",
    "pack": "Tuuta",
    "straws": "Qacceewwan",
    "createdAt": "Uumame At",
    "sireID": "ID Abbaa",
    "economicIndexValue": "Gatii Indeeksii Diinagdee",
    "latestCollectionDate": "Guyyaa Walitti qabama Yeroo Ammaa",
    "locationId": "Bakka Id",
    "lastUpdated": "Yeroo Dhumaaf Fooyya'e",
    "print": "Maxxansa",
    "save": "Qusachuu",
    "tax": "Gibira",
    "phoneNo": "Lakk Bilbilaa",
    "exportAsPDF": "Akka PDF tti erguu",
    "statusUpdated": "Haalli Haaromfame",
    "statusNotUpdated": "Haalli Hin Fooyyessine",
    "inProgress": "Adeemsa Irra Jira",
    "assignedTo": "Ramadameef",
    "taskId": "Hojii id",
    "createdDate": "Guyyaa uumame",
    "numberOfAnimals": "Baay'ina Beeyladaa",
    "healthRecordSubmittedSuccess": "Galmee Fayyaa Milkaa'inaan dhiyaate",
    "healthRecordSubmitted": "Galmeen Fayyaa Galmee.",
    "InseminationRecordSubmittedSuccesful": "Galmee Insemination Milkaa'inaan dhiyaateera",
    "inseminationRecordSubmitted": "Galmeen Insemination Dhiheefame.",
    "actionListDailyTask": "Tarree Gochaa - Hojii Guyyaa Guyyaa",
    "sinceLastYear": "Bara Dabre irraa eegalee",
    "sinceLastQuarter": "Erga Kurmaana darbee",
    "sinceLastMonth": "Ji'a Dabre irraa eegalee",
    "sinceLastWeek": "Torban Dabre irraa eegalee",
    "drugWithdrawPeriod": "Yeroo Qoricha Baasu",
    "diagnosisName": "Maqaa Qorannoo",
    "animalWithNoGenetype": "Bineensi kun daataa Jeenootaayipii galmaa'e tokkollee hin qabu. ",
    "nameOfPreviousOwner": "Maqaa Abbaa Qabeenyaa Duraa",
    "avatarSize": "Avatar size 1 MB gadi ta'uu qaba!",
    "testDestination": "Bakka Qormaataa",
    "animalNotAdded": "Beeylada Hin Dabalame",
    "registerationSuccessful": "Galmeen Milkaa'e",
    "backToAnimalList": "Gara Tarree Beeyladaatti Deebi'i",
    "addAnotherAnimal": "Beeylada biraa itti dabali",
    "animalDetailsUpdated": "Bal'inni bineensotaa milkaa'inaan haaromfame",
    "animalUpdatedSuccessfully": "Beeylada Milkaa'inaan Haaromfame",
    "animalNotUpdated": "Beeylada Hin Haaromfamne",
    "notMember": "Miseensa mitii?",
    "requestAccess": "Akka qaqqabummaa gaafadhu",
    "typePassword": "Mee jecha icciitii barreessi.",
    "minChars": "yoo xiqqaate arfiilee 6 qaba",
    "typeConfirmPassword": "jecha icciitii mirkaneessuu barreessi",
    "passConfig": "Mirkaneessi jecha icciitii wal hin simne.",
    "invalidEmailMobile": "Akkaataa email/mobaayila sirrii hin taane",
    "passwordNotEmpty": "Password duwwaa ta'uu hin danda'u",
    "passwordLength": "Dheerinni jecha icciitii arfiilee 8 gadi ta'uu hin danda'u",
    "cityVillage": "Magaalaa / Ganda",
    "districtRegion": "Aanaa / Naannoo",
    "alreadyHaveAnAccount": "Alreday account qabduu?",
    "genetypeUpdated": "GenoType Haaromfame",
    "genetypeNotUpdated": "GenoType Hin Fooyyessine",
    "sellTrade": "Gurgurtaa/Daldala",
    "milkingDevon": "Milking Devon Breeding Stock Gurgurtaaf",
    "detailedDescription": "Ibsa Bal'aa",
    "longPara": "American Milking Devon Bulls re'ee fi re'oota. ",
    "contactSeller": "Gurguraa qunnamaa",
    "enterListingTitle": "Mata duree Tarree galchi",
    "livestocktype": "Gosa Beeyladaa",
    "uploadImage": "Suuraa Tokko Olkaa'aa",
    "mobilePhone": "Lakkoofsa Bilbila Mobaayilaa",
    "myLivestock": "Beeylada Koo",
    "livestockObservations": "Ilaalcha Beeyladaa",
    "selectFromRegisteredAnimals": "Tarree Bineensota Galmaa'an Irraa Filadhu",
    "selectOption": "Filannoo filadhu",
    "selectTypeObservation": "Gosa Ilaalcha Filadhu",
    "attachVeteinaryDocument": "Sanada Fayyaa Beeyladaa Walitti Qabsiisi",
    "addsensorReading": "Dubbisa Sensaraa Dabaluu",
    "myDocument": "Sanadoota Koo",
    "enterAKeyword": "Jecha ijoo galchi",
    "documentType": "Gosa Galmee",
    "registerEditLivestock": "Beeylada Galmeessuu/Gulaaluu",
    "editLivestockProfile": "Profaayilii Beeyladaa Gulaali",
    "copy": "Koppii godhaa",
    "dateOfRegister": "Guyyaa Galmee",
    "livestockType": "Gosa Beeyladaa",
    "registerNewLivestock": "Beeylada Haaraa Galmeessaa",
    "enterUniqueTag": "Taagiin Addaa Galchi",
    "color": "Halluu",
    "gender": "Koorniyaa",
    "male": "Dhiira",
    "female": "Dhalaa",
    "damm": "Hidhaa",
    "siree": "Abbaa",
    "dateOfSaleAuction": "Guyyaa Gurgurtaa/Gurgurtaa Caalbaasii",
    "auctionRecord": "Galmee Caalbaasii Tarree Du'aa",
    "distinguishingFeatures": "Amaloota Adda Baasan",
    "keywordListing": "Jecha ijoo ykn ID Tarreefama",
    "adType": "Gosa Beeksisa",
    "activeListingFund": "1 Tarreefama Socho'aa Argame",
    "setupSensors": "Sensaroota Saagi",
    "serialNumber": "Lakkoofsa Tartiiba",
    "sensorLocation": "Bakka Sensara",
    "sensorType": "Gosa Sensaraa",
    "installationDate": "Guyyaa Dhaabbii",
    "ExpirationDate": "Guyyaa Dhuma Isaa",
    "addGeo": "Geolocation itti dabali",
    "addMoreSensors": "Sensaroota Dabalata Dabaluu",
    "trackAndTrace": "Hordoffii fi Hordoffii",
    "createNewShipment": "Ergaa Haaraa Uumuu",
    "workflowReference": "Wabii Adeemsa Hojii",
    "invoiceDate": "Guyyaa Invoice",
    "trackShipment": "Ergaa Hordofaa",
    "totalShipments": "Ergaa Waliigalaa",
    "activeShipment": "Ergaawwan Sochii Qaban",
    "completedObjectives": "Kaayyoo Xumurame",
    "processedPayments": "Kaffaltii Adeemsifame",
    "pointOfDestination": "Qabxii Itti geessan",
    "sellerInformation": "Odeeffannoo Gurguraa",
    "selectSellerConsignor": "Gurguraa/Ergisaa filadhu",
    "pointOfOrigin": "Qabxii Ka’umsaa",
    "buyerInfo": "Odeeffannoo Bittaa",
    "selectBuyerConsignor": "Bituu/Ergisaa filadhu",
    "addSensorTriggers": "Sensor Triggers Dabaluu",
    "processPayments": "Adeemsa Kaffaltii",
    "defineShippingContract": "Waliigaltee Geejjibaa Hiikkaa",
    "addDigitize": "Ida'uu",
    "currentlyOnFarm": "Yeroo ammaa kana Farm irratti",
    "addSire": "Sire itti dabali",
    "addApproval": "Raggaasifamuu Dabaluu",
    "addCollection": "Walitti qabama Dabaluu",
    "addStraws": "Straws itti dabaluudhaan",
    "addPack": "Paakkii Dabaluu",
    "addPostage": "Poostaa Dabaluu",
    "searchBySire": "Search By Sire",
    "anyDataChangeMightBeLost": "Jijjiiramni deetaa kamiyyuu baduu danda'a",
    "wouldYouLikeToSaveOrWantToLeaveWithoutSaving": "Qusachuu barbaadda moo osoo hin qusatin bahuu barbaaddaa",
    "leave": "Gad dhiisi",
    "stay": "Turuu",
    "animalFarm": "Qonna Beeyladaa",
    "animalFarmH": "Qonna Beeyladaa",
    "animalOrigin": "Madda Bineensota",
    "animalOriginH": "Madda Bineensota",
    "farmOfOrigin": "Qonna Ka'umsaa",
    "farmOfOriginH": "Qonna Ka'umsaa",
    "selectFarm": "Qonna filadhu",
    "searchFarm": "Barbaadi Qonna",
    "confirmation": "Mirkaneessaa",
    "proceed": "Itti fufi",
    "ok": "TOLE",
    "animal": {
      "tagH": "Adda baasuuf mallattoo wayitti maxxanfamu",
      "tagNumberH": "Lakkoofsa Tag: Halluu akkasumas lakkoofsa dabaluu dandeessa. ",
      "goveRegNoH": "Lakkoofsa yeroo jaarmiyaa mootummaa tokkotti galmaa’an kenname",
      "birthWeightH": "Ulfaatina Dhalootaa Re'ee",
      "birthEaseH": "Beeylada keessatti dhalachuun adeemsa uumamaa ta’us yeroo tokko tokko bakka hidhichi qonnaan bulaa/tiksee irraa gargaarsa barbaadutti rakkoon dhalootaa jiraachuu danda’a.",
      "birthFarmH": "Qonna madda/dhaloota bineensotaa.",
      "surrogateDamH": "ID re’ee dubaraa hanqaaquu dhiira arjoomtuu fi dubara arjoomtuu irraa dhalate guddina isaa dabalataaf itti dhaabamu.",
      "ownerH": "Kun maqaa abbaa bineensichaati.",
      "damH": "ID warra/haadha bineensichaa dubartii.",
      "sireH": "ID Warra/abbaa dhiiraa bineensichaa.",
      "breedH": "Sanyii garee addaa bineensota manaa bifa walfakkaataa (feenootayipii), amala walfakkaataa, fi/ykn amala biroo orgaanizimoota biroo gosa walfakkaataa irraa adda isa taasisanidha.",
      "conceptionMethodH": "Akkaataa bineensichi itti ulfoofte.",
      "genderH": "Saala bineensichaa.",
      "dobH": "Guyyaa dhaloota bineensichaa.",
      "operatorH": "Maqaa nama odeeffannoo bineensa kanaa guutee.",
      "removalFarmH": "Qonna Beeyladaa Buqqifame ",
      "dateOfRemovalH": "Guyyaa bineensi itti baafame",
      "destinationOfRemoval": "Bakka bineensi buqqifame itti geessan",
      "reasonOfRemovalH": "Sababni bineensi itti baafame",
      "trackingNumberH": "Lakkoofsa yeroo bineensichi baafamu bineensichaaf ramadame",
      "brandH": "Brand-Simply mallattoo dhaabbataa kan re'ee irratti gubate.",
      "tattoH": "Tattoo bineensa irratti.",
      "hornStatusH": "Bineensichi gaanfa irraa baafamuu fi dhiisuu isaa.",
      "animalOriginH": "Biyya ka’umsa bineensaa.",
      "previousOwnerH": "Maqaa abbaa qabeenyaa bineensichaa duraanii yoo bilchaataa ta’e.",
      "twinH": "Dirreen kun bineensichi lamaan qabaachuu fi dhiisuu isaa dubbata.",
      "regBreedAssoNoH": "Waldaalee/Waldaalee sanyii waliin galmaa’uu.",
      "breedAssoNameH": "Maqaa Waldaalee/Waldaalee bineensichi itti galmaa’e",
      "breederH": "Kun maqaa dhaabbata bineensicha dhiyeesseedha.",
      "breeder": "Horsiisaa",
      "noteH": "Yaadannoo(wwan) barbaachisaa waa’ee bineensichaa.",
      "accuracyWeight_for_field": "Ulfaatina Sirrummaa",
      "conception": "Ulfa ulfaa’uu",
      "addAnAnimal": "Beeylada Dabalaa",
      "addAnimal": "Beeylada itti dabali",
      "registerAnAnimal": "Beeylada Galmeessaa",
      "uploadAnAnimal": "Bineensa tokko olkaa'i",
      "animalRegistration": "Galmee Beeyladaa",
      "animalDetails": "Bal'ina Beeyladaa",
      "tag": "Adda baasuuf mallattoo wayitti maxxanfamu",
      "tagNumber": "Lakkoofsa Tag",
      "govtRegNumber": "Govt. ",
      "birthWeight": "Ulfaatina Dhalootaa (lbs) .",
      "birthEase": "Dhaloota Salphaa",
      "birthFarm": "Qonna Dhalootaa",
      "surrogateDam": "Hidha Bakka Bu’aa",
      "owner": "Abbaa",
      "ownershipType": "Gosa Abbummaa",
      "animalDiseaseRecord": "Galmee Dhukkuba Beeyladaa",
      "govtReg": "Govt. ",
      "regDate": "Guyyaa Galmaa",
      "dam": "Hidhaa",
      "sire": "Abbaa",
      "heifer": "Saawwan re’ee",
      "steer": "Steer",
      "calf": "Jabbii",
      "farmHerd": "Qonna/Tuuta",
      "femaleCalf": "Re'ee Dubartii",
      "maleCalf": "Re'ee Dhiiraa",
      "newCalves": "Re'oota Haaraa",
      "breed": "Horsiisuu",
      "conceptionMethod": "Mala Ulfa",
      "gender": "Koorniyaa",
      "dateOfBirth": "Guyyaa Dhalootaa",
      "operator": "Opereetara",
      "animalRemovedFarm": "Qonna Beeyladaa Buqqifame",
      "dateOfAnimalRemoval": "Guyyaa Beeylada Buqqisuu",
      "destinationOfRemovedAnimal": "Bakka Bineensi Buqqifame",
      "reasonOfRemoval": "Sababa Buqqisuu",
      "optionalAnimalInformation": "Odeeffannoo Beeyladaa Filannoo",
      "animalPicture": "Suuraa Beeyladaa",
      "trackingNumber": "Lakkoofsa Hordoffii",
      "brand": "Maqaa oomishaa",
      "tatto": "Tattoo",
      "hornStatus": "Haala Gaanfa",
      "animalOrigin": "Madda Bineensota",
      "previosOwner": "Previos Abbaa Qabeenyaa",
      "twin": "Lamaan",
      "InABreedAssociation": "Reg.",
      "nameOfBreedAssociations": "Maqaa Waldaalee Sanyii",
      "breedAssociations": "Waldaalee Sanyii",
      "breederSupplier": "Horsiisaa (Dhiyeessaa) .",
      "importAnimal": "Beeylada Galchuu",
      "loadingAnimals": "Loading Bineensota... Mee eegaa",
      "totalRegAnimals": "Waliigala Reg. ",
      "totalPregnantAnimals": "Waliigala Beeylada Ulfaa",
      "pregnantAnimalHistory": "Seenaa Beeylada Ulfaa",
      "dailyAnimalPregnancyUpdates": "Odeeffannoo Ulfa Beeyladaa Guyyaa Guyyaan",
      "animalHistory": "Seenaa Beeyladaa",
      "dailyAnimalUpdates": "Guyyaa Guyyaan Odeeffannoo Beeyladaa",
      "totalPregnant": "Waliigala Ulfaa",
      "totalNewBorn": "Waliigala Haaraa Dhalate",
      "searchByIDGOVRegTag": "Search By ID,GOV Reg fi Tag",
      "noANIMALAVAILABLE": "BINEENSA HIN ARGAMU",
      "associationNumber": "Lakkoofsa Waldaa",
      "associationName": "Maqaa Waldaa",
      "destinationName": "Maqaa Bakka Galma",
      "plastic": "Pilaastikaa",
      "metal": "Sibiila",
      "naturalMating": "Walhormaata Uumamaa",
      "artificialInsemination": "Walhormaata Namtolchee",
      "embryoTransfer": "Dabarsa Miciree",
      "noAssistance": "Gargaarsa Hin Qabu",
      "someAssistance": "Gargaarsa Tokko Tokko",
      "mechanicalAssistance": "Gargaarsa Makaanikaa",
      "aCesareanSection": "Kutaa qaama saalaa dhiiraa (cesarean section).",
      "abnormalDelivery": "Da'umsa Hin Baramne",
      "male": "Dhiira",
      "female": "Dhalaa",
      "castrated": "Castrated jedhamuun kan beekamu",
      "sale": "Gurgurtaa",
      "slaughter": "Qaluu",
      "death": "Du'a",
      "theft": "Hanna",
      "other": "Kan biraa",
      "horned": "Gaanfa kan qabu",
      "polled": "Polled ta'e",
      "dehorned": "Gaanfa irraa buqqifame",
      "details": "Gadifageenyaan",
      "performance": "Ga'umsa",
      "geneticWorth": "Gatii Jeneetikii",
      "healthRecord": "Galmee Fayyaa",
      "genotypeData": "Daataa Jeenootaayipii",
      "reminders": "Yaadachiisa",
      "activityLog": "Galmee Gochaalee",
      "activityLogDetails": "Bal'ina Galmee Gochaalee",
      "editAnimal": "Bineensa Gulaali",
      "familyInfo": "Odeeffannoo Maatii",
      "breedInfo": "Odeeffannoo Sanyii",
      "identification": "Adda baasuu",
      "removalInfo": "Odeeffannoo Buqqisuu",
      "iDOfAnimalDam": "ID hidha bineensotaa.",
      "iDOfAnimalSire": "ID abbaa bineensaa.",
      "iDOfDamEmbryoUsed": "ID hidha miciree whos fayyadame.",
      "animalHasATwinOrNot": "Bineensichi lamaan qabaachuu fi dhiisuu isaa.",
      "breedType": "Gosa Sanyii",
      "breedOfTheAnimal": "Kun sanyii bineensichaati.",
      "regBreedAssociations": "Waldaalee/ Waldaalee sanyii waliin galmeessuun.",
      "nameOfAssociationsSocieties": "Maqaa Waldaalee/Waldaalee bineensichi itti galmaa’e.",
      "nameOfTheOrgSuppliedAnimal": "Kun maqaa dhaabbata bineensicha dhiyeesseedha.",
      "countryOriginAnimal": "Biyya ka’umsa bineensaa.",
      "birthFarmID": "ID Qonna Dhalootaa",
      "farmIDAnimalBorn": "ID qonnaa bakka bineensichi itti dhalate.",
      "currentOwner": "Abbaa Qabeenyaa Ammaa",
      "nameOfOwnerAnimal": "Kun maqaa abbaa bineensichaati.",
      "registrationDate": "Guyyaa Galmee",
      "previousOwner": "Abbaa qabeenyaa duraanii",
      "nameOfOperator": "Maqaa opereteraa",
      "dateAnimalRemoved": "Guyyaa bineensi itti baafamu.",
      "destinationPlaceRemovedAnimal": "Bakka bineensi buqqifame itti geessan",
      "namePersonFillAnimalInformation": "Maqaa nama odeeffannoo bineensa kanaa guutee.",
      "reasonOfAnimalRemoval": "Sababni bineensonni itti buqqisan",
      "reasonWhyTheAnimalIsRemoved": "Sababa bineensichi maaliif akka baafamu",
      "processingDate": "Guyyaa adeemsa hojii",
      "DateInformationFilledChanged": "Guyyaa odeeffannoon ammaa itti guutame ykn jijjiirame.",
      "animalID": "ID bineensotaa",
      "UniqueIdAnimal": "Kun id addaa bineensichaati.",
      "plasticTagNumber": "Lakkoofsa Taagiin Pilaastikaa",
      "numberAnimalTag": "Lakkoofsa mallattoo Beeyladaa.",
      "rFTagNumber": "Lakkoofsa Taagi RF",
      "numberAnimalRFTag": "Lakkoofsa mallattoo RF bineensotaa.",
      "govtRegNumb": "Govt. ",
      "govtRegistrationNumber": "Bal’ina adda baasuu kan maqaa fi teessoo nama dhuunfaa, bakka bu’aa tajaajila adeemsaa nama dhuunfaa, bakka hojiin raawwatamuu qabuu fi ibsa tajaajila namni dhuunfaa sun kennu of keessatti qabachuu danda’u.",
      "numberAssignedAnimalIsRemoved": "Lakkoofsi hordoffii ID bineensotaa sochii bineensotaa hordofuuf itti fayyadaman keessaa isa tokkodha.",
      "dateOfAnimalRegistration": "Guyyaa galmee beeyladaa",
      "stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal": "Brand-Simply mallattoo dhaabbataa kan re'ee irratti gubate.",
      "tattoOnAnimal": "Tattoo bineensa irratti.",
      "whetherTheAnimalIsDehorned": "Bineensichi gaanfa irraa baafamuu fi dhiisuu isaa.",
      "milkingAnimals": "Beeylada Aannan Kennuu",
      "studAnimals": "Beeylada Stud",
      "animalInseminationRecord": "Galmee Walhormaata Beeyladaa",
      "numOfStrawsOrdered": "Lakkoofsa Qaccee Ajajame",
      "totalNumOfStraws": "Lakkoofsa Waliigalaa Qorqorroo",
      "strawId": "Id qorqorroo",
      "addSireAutomation": "Sire Automation itti dabali",
      "addApprovalAutomation": "Otoomaashiniin Raggaasifamuu Dabaluu",
      "addCollectionAutomation": "Ofumaan Walitti Qabuu Dabaluu",
      "addStrawsAutomation": "Otoomaatikii Straws Dabaluu",
      "addPackAutomation": "Otoomaatikii Paakkii Dabaluu",
      "addPostageAutomation": "Otoomaatikii Poostaa Dabaluu",
      "searchBySire": "barbaadiBySire",
      "numberOfProgenies": "Baay’ina Sanyii",
      "sireEdit": "Sire Gulaali",
      "searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId": "Id Straw, Lakkoofsa Waliigalaa straws, Batch Number fi Location Id tiin barbaadi",
      "searchByPackIdNumberOfStrawsOrderedPackingTechnicia": "Search by Pack Id, Baay'ina qorqorroo ajajame, Teeknishaa Paakkii",
      "searchByCollectionAndPreparationTechnicia": "Teeknishaa walitti qabuu fi qopheessuutiin barbaadi",
      "registerSemenAutomation": "Galmeessaa Semen Automation",
      "addSemenAutomation": "Otoomaatikii Sanyii Dabalaa",
      "strawAutomationRegistered": "Straw Automation Galmaa'eera",
      "strawAutomationRegisteredNotRegistered": "Straw Automation Galmaa'e hin Galmaa'in",
      "sireAutomationRegistered": "Sire Automation Galmaa'e",
      "sireAutomationNotRegistered": "Sire Automation Hin Galmaa'amne",
      "postageAutomationIsRegistered": "Postage Automation Galmaa'ee jira",
      "postageAutomationNotRegistered": "Otoomaashiniin Poostaa Hin Galmaa'in",
      "packAutomationIsRegistered": "Pack Automation Galmaa'ee jira",
      "packAutomationNotRegistered": "Pack Automation Hin Galmaa'in",
      "postageAutomationIsUpdated": "Otoomaashiniin Poostaa Fooyya'ee jira",
      "postageAutomationNotUpdated": "Otoomaashiniin Poostaa Hin Fooyyessine",
      "packAutomationIsUpadted": "Pack Automation Upadted ta'eera",
      "packAutomationNotUpadted": "Pack Automation Hin Upadted",
      "collectionAutomationUpdated": "Ofumaan Walitti Qabuu Fooyya'eera",
      "collectionAutomationNotUpdated": "Ofumaan Walitti Qabuu hin Fooyyessine",
      "approvalAutomationIsUpdated": "Approval Automation Fooyya'ee jira",
      "approvalAutomationIsNotUpdated": "Approval Automation Hin Fooyyeffamu",
      "collectionAutomationRegistered": "Otoomaatikii Walitti Qabuu Galmaa'e",
      "collectionAutomationNotRegistered": "Otoomaashiniin Walitti Qabuu Hin Galmaa'in",
      "approvalAutomationIsRegistered": "Approval Automation Galmaa'ee jira",
      "approvalAutomationIsNotRegistered": "Approval Automation Hin Galmaa'u",
      "strawAutomationUpdated": "Straw Automation Haaromfame",
      "strawAutomationIsNotUpdated": "Straw Automation hin Updated",
      "searchSire": "Sirba barbaadi",
      "strawsEdit": "Straws Gulaali",
      "nextAnimals": "Itti Aanu Beeylada",
      "performanceInfo": {
        "milk": "Aannan",
        "liveweight": "Ulfaatina jireenyaa",
        "score": "Qabxii",
        "fertility": "Dhala dhalachuu",
        "measurements": "Safartuuwwan",
        "dailyProteinYield": "Omisha Pirootiinii Guyyaa Guyyaa",
        "amountProteinMilkCowDay": "Hamma pirootiinii aannan guyyaa addaa sanatti re’ee irraa argamu.",
        "dailyMilkYield": "Omisha aannani guyyaa guyyaa",
        "volumeMilkCowDay": "Jildii aannan guyyaa murtaa’e tokkotti re’ee murtaa’e tokko irraa argamu.",
        "dailyFatYield": "Guyyaa Guyyaan Omisha Cooma",
        "amountFatMilkCowDay": "Hamma coomaa aannan guyyaa addaa sanatti re’ee irraa argamu.",
        "dailyProteinContent": "Qabiyyee pirootiinii guyyaa guyyaa",
        "dailyFatContent": "Qabiyyee coomaa guyyaa guyyaa",
        "milkLactose": "Laaktoosii Aannanii",
        "amountLactoseMilk": "Hamma laktoosii aannan keessa jiru.",
        "milkUrea": "Aannani Yuuriyaa",
        "indicatorAmountCrudeProtein": "Agarsiiftuu hamma pirootiinii jal’aa nyaata re’ee keessatti argamu",
        "lactationNumber": "Lakkoofsa harma hoosisuu",
        "ordinalNumLactation": "Lakkoofsa tartiiba harma hoosisuu.",
        "lengthOfLactation": "Dheerinni harma hoosisuu (fkn guyyaa 23) .",
        "lactationLength": "Dheerinni harma hoosisuu",
        "milkingFrequency": "Irra deddeebiin Aannan Kennuu",
        "frequcnyOfMilking": "Irra deddeebiin aannan itti naquu (fkn yeroo 2/ guyyaa) .",
        "liveWeightInformation": "Odeeffannoo Ulfaatina Jireenyaa",
        "currentWeight": "Ulfaatina Ammaa",
        "weightAnimal": "Ulfaatina bineensichaa.",
        "postWeaningGain": "Faayidaa Harma Hiikuu Booda",
        "dailyGainInAnimalWeightWeaning": "Guyyaa guyyaan ulfaatina beeyladaa erga harma irraa kutee booda dabaluu.",
        "weaningWeight": "Ulfaatina harma irraa kutuu",
        "weightAnimalMeasuredWeaning": "Ulfaatina beeyladaa guyyaa harma irraa kutuun safarame.",
        "averageDailyGain": "Bu'aa Guyyaa Giddugaleessaa",
        "averageAmountWeightAnimalGainFeedingPeriod": "Giddugaleessaan ulfaatina bineensi tokko yeroo nyaataa keessatti guyyaa guyyaan dabalu",
        "carcassWeight": "Ulfaatina reeffaa",
        "weightAnimalsHideInternalOrgansRemoved": "Ulfaatinni bineensotaa erga mataan, gogaan fi qaamota keessaa baafamanii booda.",
        "weightAtCalving": "Ulfaatina yeroo da’umsaa",
        "weightAtTheTimeOfCalving": "Ulfaatina yeroo da’umsaa.",
        "yearlingWeight": "Ulfaatina Waggaa",
        "weightYearOldAnimal": "Ulfaatina bineensa waggaa tokkoo.",
        "somaticCellScore": "Qabxii seelii soomaatikii",
        "somaticCellScoreIndicatorMastitis": "Qabxiin seelii soomaatikii akka agarsiiftuu dhukkuba mastitis. ",
        "lastUpdate": "Fooyya'iinsa Dhumaa",
        "bodyConditionScore": "Qabxii haala qaamaa",
        "scoreAnimalFat": "Qabxii bineensaa cooma meeqa akka qabu ilaalchisee.  ",
        "teatScore": "Qabxii harmaa",
        "scoreMeasureingShapeTeats": "Qabxiin guddina harmaa madaallii subjective dheerina fi naannoo harmaa yoo ta’u 9 (baay’ee xiqqaa) hanga 1 (baay’ee guddaa) ta’a. ",
        "udderScore": "Qabxii Udder Suspension",
        "scoreMeasureingShapeOfUdder": "Qabxii safartuu boca udda (qabxii 1-9). ",
        "whetherAnimalEasyBirthDifficult": "Beeylada keessatti dhalachuun adeemsa uumamaa ta’us yeroo tokko tokko bakka hidhichi qonnaan bulaa/tiksee irraa gargaarsa barbaadutti rakkoon dhalootaa jiraachuu danda’a.",
        "totalLongevity": "Umurii Dheeraa Waliigalaa",
        "survivalLactationTraitCowCulledBreeding": "Harma hoosisuu 1ffaa hanga 5ffaatti lubbuun jiraachuu. ",
        "docility": "Docility (Docility) kan jedhu",
        "circumferenceBullScrotal": "Naannoo qaama saalaa re’ee",
        "intervalSuccessInsemination": "Yeroo jalqabaa irraa kaasee hanga walhormaata milkaa’aa ta’etti gidduu jiru.",
        "ageAtFirstCalving": "Umurii Yeroo Jalqaba Da’umsaa",
        "ageCowCalving": "Umuriin re'ee ilmoo jalqabaa keessatti maali.",
        "calvingInterval": "Gidduu da’umsaa",
        "periodCalving": "Yeroon ilmoo tokko irraa kaasee hanga da’umsa itti aanutti.",
        "scrotalCircumference": "Naannoo Scrotal",
        "estrusDetection": "Estrus Adda Baafachuu",
        "trackingBehaviorAnimalDetectingEstrus": "Amala sochii bineensaa hordofuu estrus re’ee adda baasuuf.",
        "presenceOfEstrus": "Argama Estrus",
        "isCowInEstrusStage": "Is yeroo re'een sadarkaa estrus irra jirtu ykn nor",
        "matureWeight": "Ulfaatina Bilchaataa",
        "weightAnimalDefinedAge": "Ulfaatina bineensa tokkoo umurii murtaa’e keessatti.",
        "matureHeight": "Olka'iinsa Bilchaataa",
        "heightAnimalDefinedAge": "Dheerinni bineensa tokkoo umurii murtaa’e keessatti.",
        "footClawSet": "Seet Cirracha Miilaa",
        "shapeAnimalClaw": "Boca cirracha bineensaa.",
        "pulmonaryArterialPressure": "Dhiibbaa Arterii Sombaa",
        "animalBloodPreasure": "Dhiiga beeyladaa.",
        "footAngle": "Kofa Miilaa",
        "shapeAnimalFoot": "Boca miila bineensaa.",
        "ribEyeArea": "Naannoo Rib-eye",
        "amountRibEyeArea": "Hamma naannoo rib-eye.",
        "ultrasoundFat": "Copha Ultrasaawundii",
        "measureFatAmount": "Safartuu hamma coomaa.",
        "ultrasoundIntramuscularFat": "Ultrasound Copha Maashaalee Keessaa",
        "ultrasoundRibEyeArea": "Naannoo Rib-Eye Ultrasaawundii",
        "measureRibeyeArea": "Safartuu naannoo ribeye.",
        "fatThickness": "Fulbaana Cophaa",
        "amountAnimalBackFat": "Hamma cooma dugda bineensotaa.",
        "marbling": "Marbling jedhamuun beekama",
        "marballingMeasurement": "Marbling cooma maashaa keessaa kan hin guutamne (fayyaa) kan mul’atu kan maashaa keessaa fi baandaa fiber maashaa gidduutti kuufamuudha.",
        "dryMatterIntake": "Fudhannaa Wantoota Goggogaa",
        "amountFeedAnimalConsumesAMoisture": "Hamma nyaata bineensi tokko guyyaatti jiidhina irraa bilisa ta’een nyaatu."
      },
      "feedsName": "Maqaa Nyaata",
      "feedName": "Maqaa Nyaataa",
      "firstFeedQuantity": "Baay’ina Nyaata Duraa",
      "additionalFeed": "Nyaata Dabalataa",
      "cloversRyeGrasses": "Clovers, Marga Raayi",
      "greenFodderHayLegumes": "Nyaata Magariisaa, Hay, Legumes",
      "feedsRegisteredSuccessfully": "Nyaata Milkaa'inaan Galmaa'e",
      "feedsNotRegistered": "Nyaata Hin Galmaa'in",
      "fEEDQUANTITY": "BAAY’INA NYAATA",
      "feedQuantity": "Baay’ina Nyaata Nyaataa",
      "fEEDNAME": "MAQAA NYAATA",
      "nOFEEDINFOAVAILABLE": "ODEEFFANNOO NYAATAA HIN JIRU",
      "searchByFeedName": "Maqaa Feed tiin barbaadi",
      "loadingFeedInfo": "Loading Feed Info... Mee eegaa",
      "todayFeedInfo": "Har'a Feed Info",
      "feedInfo": "Odeeffannoo Nyaataa",
      "loremIpsumDolorSitAmet": "Loorem ipsum dolor taa'uu amet, consectetur adipiscing elit. ",
      "geneticWorthInfo": {
        "breedingValueEconomicIndex": "Gatiin walhormaataa kun shallaggii indeeksii dinagdeetiif kan oolu ta’uu fi dhiisuu isaa.",
        "dailyProteinYieldUsed": "Omisha Pirootiinii Guyyaa Guyyaa Fayyadamaa",
        "weightAssignedBreedingDailyProteinYield": "Ulfaatina gatii walhormaataa \"Oomisha pirootiinii guyyaa guyyaa\" wajjin walsimutti ramadame. ",
        "dailyProteinYieldWeight": "Ulfaatina Omisha Pirootiinii Guyyaa Guyyaa",
        "rankAnimalInRelationshipEconomicIndex": "Sadarkaa bineensaa indeeksii dinagdee wajjin walqabatee.",
        "economicIndexRank": "Sadarkaa Indeeksii Diinagdee",
        "percentileEconomicIndexFall": "Percentile indeeksii dinagdee kam keessa akka bu’u.",
        "economicIndexPercentile": "Indeeksii Diinagdee Dhibbeentaa",
        "accuracyOfEconomicIndex": "Sirrummaa indeeksii dinagdee.",
        "economicIndexAccuracy": "Sirrummaa Indeeksii Diinagdee",
        "weightedAverageOfBreedingValues": "Giddugaleessa ulfaataa gatiiwwan walhormaataa.",
        "economicIndex": "Indeeksii Diinagdee",
        "rankOfAnimalInRelationshipBreeding": "Sadarkaa bineensaa gatii walhormaataa walgitu waliin walqabatee.",
        "dailyProteinYieldBreedingValueRank": "Sadarkaa gatii walhormaataa oomisha pirootiinii guyyaa guyyaa ",
        "percentileBreedingFalls": "Percentile gatii walhormaataa kam keessa akka bu’u.",
        "dailyProteinYieldBreedingPercentile": "Omisha pirootiinii guyyaa guyyaa gatii walhormaataa parsantii ",
        "accuracyEstimatedBreeding": "Sirrummaa tilmaama gatii walhormaataa.",
        "dailyProteinYieldBreedingAccuracy": "Sirrummaa Gatii Walhormaata Omisha Pirootiinii Guyyaa Guyyaa",
        "estimatedBreedingTraitDailyProteinYield": "Tilmaama gatii walhormaataa amala \"Oomishni pirootiinii guyyaa guyyaa.\"",
        "dailyProteinYieldBreedingValue": "Gatii Walhormaata Omisha Pirootiinii Guyyaa Guyyaa ",
        "pathToTheDirectoryScriptsBreeding": "Daandii gara galmee hard drive irratti iskiriiptii of keessaa qabu kan shallaggii gatii walhormaataaf fayyadame.",
        "scriptsPath": "Daandii Iskiriiptii",
        "softwarePackageBreeding": "Paakeejii sooftiweerii kan gatii walhormaataa shallaguuf itti fayyadame.",
        "breedingValueSoftware": "Software Gatii Walhormaataa",
        "methodCalculateBreeding": "Mala walhormaata shallaguuf itti fayyadamaa ture",
        "breedingValueMethod": "Mala Gatii Walhormaataa",
        "trait": "Amala",
        "tools": "Meeshaalee",
        "geneticWorth": "Gatii Jeneetikii",
        "dailyProteinYield": "Omisha Pirootiinii Guyyaa Guyyaa",
        "breedingValue": "Gatii Walhormaataa",
        "breedingValueBIFAccuracy": "Gatii Walhormaataa Sirrummaa BIF",
        "breedingValuePercentile": "Gatii Walhormaataa Dhibbeentaa",
        "breedingValueRank": "Sadarkaa Gatii Walhormaataa",
        "checkLTD": "LTD ilaali",
        "ultrasoundDiagnostic": "Altiraasaawundii Qorannoo",
        "selectYieldUsed": "Omisha fayyadame filadhu",
        "softwareName": "Maqaa sooftiweerii",
        "animalGenWorthUpdatedSuccessfully": "Animal Gen Worth updated Milkaa'inaan"
      },
      "addNote": "Hubachiisa Dabaluu",
      "enterNote": "Hubachiisa galchi",
      "noteIsRequired": "Hubachiisa barbaachisa",
      "noteMustBeLessThan50Characters": "Hubachiisa arfiilee 50 gadi ta'uu qaba",
      "noteAdded": "Hubachiisa Dabalata",
      "noteNotAdded": "Hubachiisa Hin Dabalamne",
      "noteForAnimal": "Hubachiisa bineensotaaf.",
      "noNoteFoundForThisAnimal": "Bineensa kanaaf yaadannoo hin argamne.",
      "inseminationData": "Daataa Insemination",
      "nameOfInseminator": "Maqaa inseminator",
      "activity": "Hojii",
      "searchByNameActivity": "Maqaa, gochaan barbaadi",
      "searchByTaskNameNumber": "Maqaa hojii, lakkoofsaan barbaadi",
      "inseminationDate": "Guyyaa Walhormaata",
      "genotypeDataInfo": {
        "genotypeAnimalID": "Jeenootaayipii ID Beeyladaa",
        "iDTubeBloodSampleAnimalNumberGenotypingService": "Kun ID tuubii saamuda dhiigaa bineensicha irraa fudhatame ykn tajaajila jeenootaayipii lakkoofsa qabuudha",
        "geneticTechnicianName": "Maqaa Teeknishaan Jeneetikii",
        "NameTechnicianBloodSamplesAnimal": "Kun maqaa ogeessa saamuda dhiigaa bineensicha irraa fudhateeti",
        "sNPData": "Daataa SNP",
        "genotypingServiceNote": "Tajaajila Jeenootaayipii Hubachiisa",
        "InfoGenotypingGenotypingTechnology": "Odeeffannoowwan jeenootaayipiin walqabatan hunda kan akka maqaa dhaabbata jeenootaayipii, teeknooloojii jeenootaayipii fayyadame, guyyaa jeenootaayipii fi kkf",
        "numberOfSNPs": "Baay’ina SNP",
        "numberOfSNPsAnimalGenotyped": "Baay’ina SNP bineensichi jeenootaayipii itti godhame",
        "nameOfTheDrug": "Maqaa Qoricha",
        "animalGenoDataUpdatedSuccessfully": "Daataan Jeenoo Beeyladaa Milkaa'inaan Fooyyeffame",
        "animalGenoDataNotUpdated": "Daataan Jeenoo Beeyladaa Hin Fooyyessine",
        "animalIDIsRequired": "ID bineensaa barbaachisaadha",
        "techNameIsRequired": "Teeknooloojii. ",
        "onlyAlphabetsAreAllowed": "Qubee qofatu hayyamama",
        "genoDataIsRequired": "Daataan jeenoo barbaachisaadha",
        "serviceNoteIsRequired": "Hubachiisa Tajaajilaa barbaachisa",
        "sNPIsRequired": "SNPn barbaachisaadha"
      },
      "healthRecordInfo": {
        "treatment": "Wal'aansa",
        "treatmentTakenAnimal": "Wal'aansi akkamii bineensa irratti fudhatame.",
        "reasonOfTreatment": "Sababa Wal'aansa",
        "reasonForTreatment": "Sababa Wal'aansaaf",
        "whatReasonOfTreatment": "Sababni wal'aansaa maali.",
        "treatmentDate": "Guyyaa Wal'aansa",
        "dateOfTreatment": "Guyyaa wal'aansaa.",
        "diagnosis": "Qorannoo dhukkuba",
        "nameDiagnosedDiseaseConditionSymptoms": "Maqaa dhukkuba/haala ykn mallattoolee ijoo adda baafame",
        "drugID": "ID qoricha sammuu hadoochu",
        "iDOfDrugWhichIsGivenToAnimal": "ID qoricha kan bineensaaf kennamu.",
        "drugName": "Maqaa Qoricha",
        "nameDrugAnimal": "Maqaa qoricha kan bineensaaf kennamu.",
        "drugWithdrawalPeriod": "Yeroo Qoricha Ofirraa Ittisuu",
        "timeAdministrationDrugAnimalMeatMilkHumanConsumption": "Yeroo qorichi bineensa tokkoof kennamee booda foon ykn aannan nyaata namaatiif oolu mirkaneessuuf barbaachisu",
        "attendingVeterinarian": "Ogeessa Beeyladaa Argamaa jiru",
        "qualifiedPersonCaseAnimal": "Nama gahumsa qabu kan dhimmicha/bineensa arge",
        "packID": "ID Paakkii",
        "iDPackTreatment": "ID paakkii kan yaalaaf itti fayyadame",
        "veterinarianName": "Maqaa Ogeessa Beeyladaa",
        "animalNoHealthRecord": "Bineensi kun Galmee Fayyaa tokkollee hin qaban. ",
        "addHealthRecord": "Galmee Fayyaa Dabaluu",
        "healthStatus": "Haala Fayyaa",
        "loadingDiseasesPleaseWait": "Loading Dhukkuboota... Mee eegaa",
        "animalDiseaseRecord": "Galmee Dhukkuba Beeyladaa",
        "animalHealthRecord": "Galmee Fayyaa Beeyladaa",
        "animalTreatmentRecord": "Galmee Wal'aansa Beeyladaa",
        "loadingHealthData": "Daataa Fayyaa Fe'aa jira...",
        "healthRecord": "Galmee Fayyaa",
        "nameOfDiagnosis": "Maqaa Qorannoo",
        "treatmentName": "Maqaa Wal'aansaa",
        "drugGivenBy": "Qoricha Kenneef",
        "recessiveDiseases": "Dhukkuboota Recessive Dhukkuboota",
        "recessiveDiseasesMessage": "Re'een kun alleles dhukkuba recessive kamtu baateedha"
      },
      "conceptionInfo": {
        "addNewConception": "Ulfa haaraa itti dabali",
        "semenEmbryo": "Sanyii/Miciree",
        "pregnancyCheck": "Sakatta'iinsa Ulfaa",
        "birthInfo": "Odeeffannoo Dhalootaa",
        "searchByInseminatorOrganisationBreedingConception": "Maqaa Inseminator, Maqaa Jaarmiyaa, Lakkoofsa tajaajila walhormaataa, Mala Ulfaatiin barbaadi",
        "deliveryDate": "Guyyaa Geejjibaa",
        "calfId": "Id Re'ee",
        "birthDayOldWeight": "Dhaloota (Guyyaa) Ulfaatina",
        "searchByBirthEase": "Search by Dhaloota salphaa",
        "searchPregnancyCheckOperatorMethod": "Search by Opereetara sakatta'iinsa ulfaa, Mala sakatta'iinsa ulfaa",
        "pregnancyCheckDate": "Guyyaa Sakatta'iinsa Ulfaa",
        "conceptionSuccess": "Milkaa’ina Ulfa",
        "pregnancyCheckOperator": "Opereetara Sakatta'iinsa Ulfaa",
        "pregnancyCheckMethod": "Mala Sakatta'iinsa Ulfaa",
        "recentlyPregnant": "Dhiheenya Ulfa",
        "pregnancyConfirmationDate": "Guyyaa Ulfaa Mirkaneessa",
        "pregnancyRate": "Sadarkaa Ulfaa",
        "timePeriodOfPregnancy": "Yeroo Ulfaa",
        "semenProduction": "Oomisha Sanyii Sanyii",
        "embryoProduction": "Omisha Miciree",
        "semen": "sanyii dhiiraa",
        "embryoTransferDate": "Guyyaa Dabarsa Miciree",
        "daysOfPregnancy": "Guyyoota Ulfaa",
        "searchSireEmbryoSurrogate": "Search by Sire id, Maqaa org Miciree, Sanyii hidha bakka bu'aa",
        "selectDate": "Guyyaa filadhu",
        "orgnisationNameContainNumber": "Maqaan Dhaabbataa lakkoofsa qabaachuu hin qabu",
        "selectBirthEase": "Salphaa Dhalootaa filadhu",
        "selectUnit": "Mee yuunitii tokko filadhaa",
        "animalConceptionAddedSuccessfully": "Ulfa Beeyladaa Milkaa'inaan Dabalame",
        "postageCustomerName": "Maqaa Maamilaa Poostaa",
        "searchByPostageCustNameCustAddPostId": "Maqaa Maamilaa Poostaa, Teessoo Maamilaa, Id Poostaatiin barbaadi",
        "dateOfSemenCollection": "Guyyaa Sanyii Sassaabame",
        "dateOfSemenPreparation": "Guyyaa Qophii Sanyii",
        "semenMotility": "Sochii Sanyii Sanyii",
        "semenConcentration": "Xiyyeeffannoo Sanyii dhiiraa",
        "postageEdit": "Gulaaluun Poostaa",
        "enterSireId": "ID Sire galchi",
        "selectEmbryoOrganisation": "Dhaabbata Miciree filadhu",
        "matingDateH": "Guyyaa ulfaa, yookaan walhormaata uumamaa yookaan walhormaata namtolchee.",
        "inseminatorNameH": "Nama adeemsa walhormaataa raawwatu ( ogeessa beeyladaa/teeknishaan) .",
        "orgNameH": "Maqaa dhaabbata ykn dhaabbata AI'f qodaa sanyii dhiyeessuu",
        "brServiceNumH": "Lakkoofsa walhormaataa galmeessuu (fkn 1ffaa, 2ffaa, ykn 3ffaa) .",
        "conceptionMethodH": "Akkaataan bineensi sun ulfeesse sun jalqaba ulfaati, hanqaaquu tokko isparmiidhaan walhormaataan mallatteeffame.",
        "sireIdH": "ID Warra/abbaa dhiiraa bineensichaa",
        "damIdH": "ID warra/haadha bineensichaa dubartii.",
        "sarogatedDamH": "ID re’ee dubaraa hanqaaquu dhiira arjoomtuu fi dubara arjoomtuu irraa dhalate guddina isaa dabalataaf itti dhaabamu.",
        "embOrgNameH": "Maqaa jaarmiyaa miciree",
        "sarogateDamBreedH": "Guyyaa sanyii bakka bu’aa",
        "sireBreedH": "Gosa sanyii sire ( brahman, boran) .",
        "pregCheckDateH": "Ulfi re’oota irratti qorannoo altiraasaawundii fi dhiigaa fayyadamuun guyyoota 30 irraa eegalee adda baafamuu danda’a.Re’oonni mala tuqaatti fayyadamuun ulfa ta’uu isaanii adda baasuuf yeroo baay’ee re’oonni yoo xiqqaate guyyaa 35-50 ulfa ta’uu qabu. ",
        "conceptionSuccessH": " Loon keessatti, saffisi walhormaataa %90 yoo ta’u, saffisi da’umsaa giddu galeessaan gara %55 yoo ta’u, kunis du’a miciree-daa’ima gara %35 agarsiisa (Diskin et al., 2006). ",
        "pregnancyCheckOperatorH": "Ogeeyyiin beeyladaa fi ogeeyyiin beeyladaa ispeeshaalistii yeroo baay’ee tajaajila kana qonnaan bultootaaf ni kennu. ",
        "pregnancyCheckMethodH": "Malli ulfaa loon adda baasuuf yeroo baay’ee itti fayyadaman lamaan ujummoo walhormaataa harkaan tuquu (per rectum) fi altiraasonoogiraafii qaama walhormaataa qaama saalaa keessaa (transrectal ultrasonography) dha",
        "deliveryDateH": "Guyyaa da'umsi itti raawwatamu",
        "calfIdH": "ID re'ee reefuu dhalate",
        "birthEaseH": "Beeylada keessatti dhalachuun adeemsa uumamaa ta’us yeroo tokko tokko bakka hidhichi qonnaan bulaa/tiksee irraa gargaarsa barbaadutti rakkoon dhalootaa jiraachuu danda’a.",
        "birthDayOldWeightH": "Ulfaatina bineensa guyyaa dhalootaa ykn ulfaatina simbirroo guyyaa tokkoo",
        "customerAddress": "Teessoo Maamilaa"
      },
      "all": "Hunda",
      "ungrouped": "Bineensota Garee Hin Qabne",
      "active": "Beeylada Garee",
      "updateAnimal": "Update Beeyladaa"
    },
    "dashboardS": {
      "dailyActivities": "Sochiiwwan Guyyaa Guyyaa",
      "pendingTasks": "Hojiiwwan Eegamaa Jiran",
      "performanceOfGeno": "Raawwii Hojii Jeenootaayipoota",
      "breed": "Horsiisuu",
      "chromosome": "Kiroomozoomii",
      "seqChange": "Jijjiirama Tartiiba",
      "inheritance": "Dhaala",
      "diseaseName": "Maqaa Dhukkubaa",
      "refSequence": "Tartiiba Wabii",
      "pubmedRef": "Wabii Pubmed",
      "matingDate": "Guyyaa Walhormaataa",
      "inseminatorName": "Maqaa Inseminator",
      "orgName": "Maqaa Jaarmiyaa",
      "brServiceNum": "Lakkoofsa Tajaajila Walhormaataa",
      "conceptionMethod": "Mala Ulfa",
      "semEmbInfo": "Odeeffannoo Sanyii/Miciree",
      "sireId": "ID Abbaa",
      "damID": "ID Hidha",
      "srgDamId": "ID Hidha Bakka Bu’aa",
      "embOrgName": "Miciree Org. ",
      "srgDamBreed": "Sanyii Hidha Bakka Bu’aa",
      "sireBreed": "Sanyii Abbaa",
      "damBreed": "Sanyii Hidha"
    },
    "user": {
      "selectLanguage": "Afaan Filadhu",
      "unitPreference": "Filannoo Yuunitii",
      "selectUnitOfMeasure": "Yuunitii safartuu filadhu",
      "importedUser": "Fayyadamaa Galfame",
      "impFileStatus": "Haala Faayilii Galchuu",
      "loadingUser": "Fayyadamtoota Fe'aa Jira... Mee eegaa",
      "totalUsers": "Fayyadamtoota Waliigalaa",
      "pendingUsers": "Fayyadamtoota Eegamaa Jiran",
      "changePassword": "Jecha Darbii Jijjiiri",
      "goodIdeaToUsePassword": "Jecha icciitii cimaa bakka biraatti hin fayyadamne fayyadamuun gaariidha.",
      "enterCurrentPassword": "Jecha Darbii Ammaa Galchi",
      "enterNewPassword": "Jecha Darbii Haaraa Galchi",
      "reEnterPassword": "Jecha Darbii Haaraa Irra Deebiin Galchi",
      "enterPassword": "Password galchi",
      "repeatNewPassword": "Jecha Darbii Haaraa Irra Deebi'i",
      "emailAddr": "Teessoo Imeelii",
      "enterYourPhoneNumber": "Lakkoofsa Bilbilaa Keessan Galchaa",
      "pleaseTypeOldPassword": "Mee jecha icciitii durii barreessi.",
      "pleaseTypeNewPassword": "Mee jecha icciitii haaraa barreessi.",
      "pleaseTypeConfirmPassword": "Mee confirm password barreessi.",
      "passwordChangedSuccesFully": "Password milkaa'inaan jijjiirame",
      "currentPassword": "Jecha Darbii Ammaa",
      "newPassword": "Jecha Darbii Haaraa",
      "passwordDoesNotMatch": "Jechoonni icciitii wal hin simne.",
      "emailCanNotBeEmpty": "Email duwwaa ta'uu hin danda'u",
      "profileUpdated": "Profaayilli Haaromfame",
      "profileNotUpdated": "Profaayilli Hin Haaromfamne",
      "unableToVerifyEmail": "Email mirkaneessuu hin dandeenye",
      "otpSentOnEmail": "OTP email irratti ergame",
      "otpSentSuccessFully": "OTP milkaa'inaan ergame",
      "importUsers": "Fayyadamtoota Galchuu",
      "imageUpdated": "Suuraan Haaromfame",
      "departmentName": "Maqaa Kutaa",
      "departmentNum": "Lakkoofsa Kutaa",
      "departmentAdded": "Kutaa Dabalataa",
      "departmentNotAdded": "Department hin Dabalame",
      "searchDepartnment": "Maqaa Ykn Lakkoofsa Kutaa Biirootiin Barbaadi",
      "addDepartMent": "Kutaa Dabalaa",
      "addDepartment": "Kutaa Dabalaa",
      "roleNameIsRequired": "Maqaan gahee hojii barbaachisaadha",
      "roleNameMustBeLessThan15Chars": "Maqaan gahee hojii arfiilee 15 gadi ta'uu qaba",
      "roleAdded": "Gaheen Dabalame",
      "editDepartment": "Kutaa Gulaaluu",
      "departmentUpdated": "Kutaa Haaromfame",
      "departmentNotUpdated": "Kutaan Hin Haaromfamne",
      "deleteDepartment": "Kutaa Haquu",
      "deleteDepartmentMessage": "Kutaa kana haquu akka barbaaddan mirkaneeffatteettaa.",
      "noRoleAvailable": "GAHEE HIN JIRU",
      "roleUpdated": "Gahee Hojii Haaromfame",
      "roleNotUpdated": "Gaheen Hin Fooyyessine",
      "editRole": "Gahee Gulaaluu",
      "allRole": "Gahee Hundi",
      "addNewRole": "Gahee Haaraa Dabaluu",
      "allDepartment": "Kutaa hunda",
      "permissionsUpdated": "Hayyama Haaromfame",
      "permissionsnotUpdated": "Hayyamni Hin Fooyyessine",
      "roleNo": "Gahee Lakk.",
      "searchByEmailAndName": "Imeelii fi maqaadhaan barbaadi",
      "userID": "ID fayyadamaa",
      "userUpdated": "Fayyadamaan Fooyyeffame",
      "userNotUpdated": "Fayyadamaan Hin Fooyyessine",
      "userAdded": "Fayyadamaan Dabalame",
      "userNotAdded": "Fayyadamaan Hin Dabalamne",
      "activateUser": "Fayyadamaa Hojiirra Oolchi",
      "deactivateUser": "Fayyadamaa Deactivate gochuu",
      "userStatusMsg": "Haala fayyadamaa jijjiiruu akka barbaaddu mirkaneeffatteettaa",
      "countryRequired": "Biyyatu barbaachisa",
      "stateRequired": "Mootummaan barbaachisaadha",
      "cityRequired": "Magaalaan barbaachisa",
      "searchByRole": "Lakkoofsa Gahee, Maqaa Gahee, Kutaa Hojiitiin Barbaadi",
      "noModuleAvailable": "Moojuliin Hin Jiru",
      "searchBYModuleName": "Maqaa Moojuuliin Barbaadi"
    },
    "farm": {
      "farmID": "ID Qonnaa",
      "onTheFarm": "Qonna irratti",
      "userRoles": "Gahee Fayyadamtootaa",
      "adduser": "Fayyadamaa Dabaluu",
      "addAuser": "Fayyadamaa Dabaluu",
      "uploadUsers": "Fayyadamtoota Olkaa'uu",
      "addNewUser": "Fayyadamaa Haaraa Dabaluu",
      "selectDept": "Kutaa filadhu",
      "selectRole": "Gahee Filadhu",
      "editUser": "Fayyadamaa Gulaali",
      "totalFarms": "Qonna Waliigalaa",
      "NoAnimalsRegisteredForthisFarm": "Qonna kanaaf Beeyladni Hin Galmaa'u",
      "farmsPerPage": "Qonna fuula tokko irratti",
      "regularFarms": "Qonna Idilee",
      "farmRegisteredProducts": "Oomishaalee Qonnaa Galmaa’an",
      "searchByFarmNameAndId": "Maqaa Qonnaa fi Id tiin barbaadi",
      "loadingProductsPleaseWait": "Loading Products... Mee eegaa",
      "farmName": "Maqaa Qonnaa",
      "farmLocation": "Bakka Qonnaa",
      "productName": "Maqaa Omishaa",
      "stockStatus": "Haala Istookii",
      "inStock": "In Stock keessa jira",
      "searchByProductName": "Maqaa Omishaatiin Barbaadi",
      "productCategory": "Ramaddii Omishaa",
      "products": "Oomishaalee",
      "farms": "Qonna",
      "registerAfarm": "Galmeessaa Qonna A",
      "govtRegistry": "Govt. ",
      "cooperativeID": "ID waldaa hojii gamtaa",
      "farmType": "Gosa Qonnaa",
      "contractMating": "Walhormaata Waliigaltee",
      "customization": "Akkaataa barbaadetti jijjiiruu",
      "recordsPerpage": "Galmee Fuula tokko irratti",
      "restoreDefault": "Durtii Deebisuu",
      "apply": "Hojiirra oolchuu",
      "searchState": "Search by Farm ID, Gov. Registry, ID Waldaa Hojii Gamtaa, Gosa Qonnaa, Walhormaata Waliigaltee",
      "farmOwner": "Abbaa Qonnaa",
      "govRegistrationNo": "Lakkoofsa Galmee Mootummaa",
      "farmInformation": "Odeeffannoo Qonnaa",
      "ownershipType": "Gosa Abbummaa",
      "communityName": "Maqaa Hawaasa",
      "farmLicenseInformation": "Odeeffannoo Hayyama Qonnaa",
      "licenseNumber": "Lakkoofsa Hayyamaa",
      "licenseExpiryDate": "Guyyaa Dhuma Hayyama",
      "regulatorName": "Maqaa Regulaatorii",
      "regulatorRepresentativeName": "Maqaa Bakka Bu’aa Regulaatorii",
      "farmLocationSize": "Bakka Qonnaa",
      "productionSystem": "Sirna Omishaa",
      "country": "Biyya",
      "state": "Ibsuu",
      "city": "Magaalaa",
      "street": "Daandii",
      "houseNumber": "Lakkoofsa Manaa",
      "farmRegistration": "Galmee Qonnaa",
      "cancel": "Haquu",
      "register": "Galmeessuu",
      "ok": "tole",
      "totalFarmSize": "Waliigala Guddina Qonnaa",
      "farmGeographicLocation": "Bakka Ji’ograafii Qonnaa",
      "perimeterPointLongitude": "Qabxii Naannoo Loongituudii",
      "perimeterPointLatitude": "Laatituudii Qabxii Naannoo",
      "perimeterPointLabel": "Asxaa Qabxii Naannoo",
      "perimeterLength": "Dheerinni Naannoo",
      "farmLatitude": "Latitude Qonnaa",
      "farmLongitude": "Longitude Qonnaa",
      "editFarm": "Qonna Gulaali",
      "update": "Odeeffannoo dhiyeenyaa",
      "editAfarm": "Qonna tokko gulaali",
      "nextFarm": "Itti Aanu Qonna",
      "nameoftheFarm": "Maqaa Qonnaa",
      "registerAProduct": " Galmeessaa Oomisha A",
      "farmProducts": "Oomisha Qonnaa",
      "calf": "Jabbii",
      "steer": "Steer",
      "heifer": "Saawwan re’ee",
      "sire": "Abbaa",
      "dam": "Hidhaa",
      "registerAnAnimal": "Beeylada Galmeessaa",
      "farmAnimals": "Beeylada Qonnaa",
      "farm_type": "Gosa qonnaa",
      "farm_Owner": "Qonna-Abbaa Qabeenyaa",
      "dateOfRegistration": "Guyyaa Galmee",
      "dataIsNotAvailableForThisFarm": "Daataan Qonna kanaaf Hin argamu",
      "registerNewProduct": "Omisha Haaraa Galmeessaa",
      "information": "Odeeffannoo",
      "licenseInfo": "Odeeffannoo Hayyamaa",
      "locationInfo": "Odeeffannoo Bakka",
      "geoLocation": "Geo Bakka",
      "perimeterLengthState": "Dheerinni Qonnaa Naannoo (dheerina dallaa) .",
      "totalFarmSizeState": "Guddina Qonna tokkoo",
      "productionSystemState": "Sirna Omishaa Qonna keessatti fayyadamu",
      "contractMatingState": "Sagantaa Walhormaataa Dambii Kontiraataa Qonnaan bulaan Hirmaatu.",
      "ownershipTypeState": "Gosa Abbummaa",
      "regulatorRepresentativeNameState": "Maqaa nama regulator bakka bu’ee hayyama gadhiise",
      "regulatorNameState": "Maqaa regulator hayyama gadhiise",
      "licenseExpiryDateState": "Guyyaa Hayyamni ammaa Dhuma",
      "licenseNumberState": "Lakkoofsa Hayyamaa Regulaatoriin gadhiifame",
      "plotNumberState": "Lakkoofsa mana qonnaa.",
      "plotNumber": "Lakkoofsa Manaa/Plot",
      "streetStatement": "Maqaa daandii qonnaa.",
      "cityStatement": "Magaalaa qonni itti argamu.",
      "stateStatement": "Naannoo biyya qonni itti argamu.",
      "countryState": "Biyya qonni itti argamu.",
      "perimeterPointLongitudeState": "Longitude qabxii tokkoo qonna irratti.",
      "perimeterPointLatitudeState": "Latitude qabxii tokkoo qonna irratti.",
      "perimeterPointLabelState": "Asxaa Qabxii.",
      "farmLongitudeState": "Longitude qonnaa sanaa.",
      "farmLatitudeState": "Latitude qonnaa sanaa.",
      "farmNameH": "Maqaa qonnaa",
      "farmTypeH": "Gosa qonnaa hojiiwwan adda addaa itti raawwataman.",
      "farmOwnerH": "Maqaa abbaa qonnaa (auto-generate Maqaa qonnaan bulaa info galchuu) .",
      "ownershipTypeH": "Gosa qonnaan bulaa lafa qonnaan bulaa qaban/to’atanii fi kan hin qabne.",
      "govtRegNumbH": "Lakkoofsa galmee qonnaa kan regulator tiin ramadame",
      "contractMatingH": "Koodii sagantaa walhormaataa waliigaltee kan qonni itti hirmaatu",
      "productionSystemH": "Sirni oomishaa qonna irratti maal fayyadama",
      "cooperativeIDH": "ID waldaa hojii gamtaa qonnichi miseensa ta’e ",
      "licenseNumberH": "Lakkoofsa adda baasuu hayyama regulator gadhiifame irratti kan abbaa qabeenyaa waliin adda baasu.",
      "licenseExpiryDateH": "Guyyaa hayyamni ammaa itti dhume",
      "regularNameH": "Maqaa regulator hayyama gadhiise",
      "regularRepName": "Maqaa nama regulator bakka bu’ee hayyama gadhiise",
      "countryH": "Biyya qonni itti argamu.",
      "stateH": "Naannoo biyya qonni itti argamu.",
      "cityH": "Magaalaa qonni itti argamu.",
      "streetH": "Maqaa daandii qonnaa.",
      "houseNumberH": "Lakkoofsa mana qonnaa.",
      "totalFarmSizeH": "Bal’inni qonnaa lafa yeroo ammaa qonnichi lafa qonnaa jala jiru dabalatee lafa biqiltoota uumamaa, mukkeen ykn dheedichaa jala jiru osoo hin dabalatin walitti qabama.",
      "farmLatitudeH": "Safartuu fageenya kaaba ykn kibba Ikuwaatorii ti. ",
      "farmLongitudeH": "Fageenya baha ykn dhiha prime meridian safara.",
      "perimeterLengthH": "Dheerinni naannoo qonnaa (dheerina dallaa) .",
      "perimeterPointLabelH": "Asxaa qabxii. ",
      "perimeterPointLatH": "Latitude qabxii tokkoo qonna irratti",
      "perimeterPointLongH": "Longitude qabxii tokkoo qonna irratti",
      "noProductAvailable": "Omishni Hin Argamu",
      "farmUpdated": "Qonna Haaromfame",
      "performance": "Ga'umsa",
      "milkInformation": "Odeeffannoo Aannani",
      "farmNameRequired": "Maqaa Qonnaa barbaachisa"
    },
    "login": {
      "welcome": "Baga nagaan dhufte! ",
      "welInfo": "Mirkaneessa kee galchi.",
      "login": "Galmaa'i",
      "forgotPassword": "Password dagadheera",
      "forgotPasswordDesc": "Mee teessoo email akkaawuntii keessan waliin walqabatu galchaa. ",
      "backToLogin": "Gara Seensaatti Deebi'aa"
    },
    "actionListmod": {
      "actionList": "Tarree Tarkaanfii",
      "tODAY": "Har'a",
      "createTask": "Hojii Uumuu",
      "myActivities": "Hojiiwwan Koo",
      "jhonSmith": "Jhon Smith jedhamuun beekama",
      "farmID": "ID Qonnaa",
      "dateOfEvent": "Guyyaa Taatee",
      "actionRequired": "Tarkaanfii Barbaachisu",
      "actionTaken": "Tarkaanfii Fudhatame",
      "animalEventID": "ID Taatee Beeyladaa",
      "cANCEL": "Haquu",
      "cONFIRM": "Mirkaneessuu",
      "sTATEMENT": "Galmee kana haquu akka barbaaddu mirkaneeffatteettaa?",
      "dAY": "Guyyaa",
      "wEEK": "Torbee",
      "mONTH": "Ji'a",
      "sUBMIT": "Galchuu",
      "startDate": "Guyyaa Jalqabaa",
      "endDate": "Guyyaa Xumuraa",
      "rEPEAT": "Irra-deebi'uu",
      "taskCategory": "Ramaddii Hojii",
      "pRIORITY": "Dursa",
      "aSSIGNEE": "Ramaddii",
      "selectLocation": "Bakka filadhu",
      "selectAnimals": "Bineensa tokko ykn isaa ol filadhu",
      "dESCRIPTION": "Ibsa",
      "customRecurrence": "Irra Deddeebi'uu Aadaa",
      "repeatEvery": "Hundaa Irra Deebi'i",
      "taskName": "Maqaa hojii",
      "enterDescription": "Ibsa Galchi",
      "toDo": "Hojjechuuf",
      "assignTo": "Ramaddii Gara",
      "status": "Sadarkaa",
      "nOTE": "Yaadannoo",
      "noTaskAvailable": "HOJII HIN ARGAMU",
      "healthRecord": "Galmee Fayyaa",
      "iD": "ID",
      "tAG": "Adda baasuuf mallattoo wayitti maxxanfamu",
      "dateOfbirth": "Guyyaa Dhalootaa",
      "taskTakenat": "Hojii Fudhatame At",
      "gENDER": "Koorniyaa",
      "bREED": "Horsiisuu",
      "regDate": "Reg. ",
      "updateHealthRecord": "Galmee Fayyaa Beeyladaa Haaromsuu",
      "treatment": "Wal'aansa",
      "reasonOftreatment": "Sababa Wal'aansa",
      "treatmentDate": "Guyyaa Wal'aansa",
      "dIAGNOSIS": "Qorannoo",
      "drugId": "Qoricha Id",
      "drugName": "Maqaa Qoricha",
      "drugWithdrawalperiod": "Yeroo Qoricha Ofirraa Ittisuu",
      "attendingVeterinarian": "Ogeessa Beeyladaa Argamaa jiru",
      "packId": "Pack Id",
      "noItemsselected": "Wantoonni Filataman Hin Jiran",
      "healthRecordsubmission": "Galmee Fayyaa Dhiyeessuu",
      "inseminationRecordsubmission": "Insemination-Galmee Dhiyeessuu",
      "inseminatorName": "Maqaa Inseminator",
      "inseminatorId": "Inseminator Id",
      "conceptionRate": "Saffisa Ulfa",
      "dateOfmeasurement": "Guyyaa Safartuu",
      "recordSubmission": "Galmee Dhiyeessuu",
      "uPDATE": "Odeeffannoo dhiyeenyaa",
      "updateTask": "Hojii Fooyyessi"
    },
    "inseminatorStatisticsInfo": {
      "addInseminatorInfo": "Odeeffannoo Inseminator Dabaluu",
      "inseminatorNumber": "Lakkoofsa Inseminator",
      "loadingInseminatorPleaseWait": "Loading Inseminator... Mee eegaa",
      "searchByIDAndName": "ID fi Maqaadhaan barbaadi",
      "inseminatorInfoAdded": "Inseminator Info Dabalameera",
      "inseminatorInfoNotAdded": "Inseminator Info Hin Dabalamne",
      "inseminatorInfoUpdated": "Inseminator Info Haaromfame",
      "inseminatorInfoNotUpdated": "Inseminator Info hin Fooyyessine",
      "editAInseminatorInfo": "Odeeffannoo Inseminator Gulaali",
      "inseminatorList": "Tarree Inseminator",
      "inseminatorInfoDetails": "Inseminator Info Bal'inaan",
      "updateInseminatorInfo": "Odeeffannoo Inseminator Fooyyessi"
    },
    "organizationNtrInfo": {
      "loadingOrdersPleaseWait": "Loading Orders... Mee eegaa",
      "addStocks": "Stocks Dabaluu",
      "addStock": "Stock Dabaluu",
      "quantity": "Baay'ina",
      "selectUnit": "Yuunitii filadhu",
      "farmProducts": "Oomisha Qonnaa",
      "cost": "Baasii",
      "transactionID": "ID daldalaa",
      "recipientID": "ID fudhataa",
      "orderID": "ID ajaja",
      "recepientName": "Maqaa Fudhataa",
      "createAOrder": "Tartiiba uumuu",
      "totalStocks": "Waliigala Istookii",
      "orders": "Ajaja",
      "totalPending": "Waliigala Kan Eeggamaa jiru",
      "totalDelivered": "Waliigala Kan Kenname",
      "searchByRecepientNameOrderIdRecepientId": "Maqaa Fudhataa, Id Ajaja, Id Fudhataatiin Barbaadi",
      "chooseTheDate": "Guyyaa filadhu",
      "transactionDate": "Guyyaa Daldalaa",
      "selectCategory": "Gosa filadhu",
      "volumeOfProduct": "Jildii Omishaa",
      "productQuantity": "Baay’ina Omishaa",
      "productRecipientId": "Id Fudhataa Omishaa",
      "productRecipientName": "Maqaa Fudhataa Omishaa",
      "productRecipientType": "Gosa Fudhataa Omishaa",
      "singleProduct": "Omisha Tokko",
      "orderPlaced": "Tartiiba Kaa'ame",
      "orderNotPlaced": "Ajajni Hin Kaa'amne",
      "totalPrice": "Gatii Waliigalaa",
      "currency": "Maallaqa",
      "selectCurrency": "Maallaqa filadhu",
      "address": "Teessoo",
      "enterAddress": "Teessoo Galchi",
      "attachments": "Dabalata",
      "chooseFile": "Faayilii filadhu",
      "nameOfTheFarm": "Maqaa qonnaa",
      "loremIpsumHasBeenTheIndustrySStandardDummyText": "Lorem Ipsum bara 1500moota irraa eegalee barreeffama fakkeessituu istaandaardii indaastirichaa ta'ee ture, yeroo maxxansaan hin beekamne tokko fudhate",
      "billedTo": "Billed To",
      "orderStatus": "Haala Ajaja",
      "selectStatus": "Haala filadhu",
      "cadbury": "Cadbury jedhamuun beekama",
      "totalAmount": "Maallaqa Waliigalaa",
      "deliveryCharges": "Kaffaltii Geejjibaa",
      "orderDetails": "Bal'ina Ajaja",
      "deliveryOnTime": "Yeroodhaan Geejjibaa",
      "productID": "ID oomishaa",
      "productRegistration": "Galmee Omishaa",
      "enterTheNameOfTheProduct": "Maqaa oomishaa galchi",
      "nameOfTheProduct": "Maqaa Omishaa",
      "productAdded": "Omisha Dabalame",
      "productNotAdded": "Omishni Hin Dabalamne"
    },
    "drug": {
      "dRUGS": "Qoricha sammuu hadoochu",
      "registerAdrug": "Qoricha Galmeessaa",
      "sEARCH": "Barbaaduu",
      "genericName": "Maqaa Waliigalaa",
      "manufacturer": "Oomishaa",
      "distributor": "Raabsaa",
      "registrationDate": "Guyyaa Galmee",
      "drugRegistration": "Galmee Qorichaa",
      "drugInformation": "Odeeffannoo Qoricha",
      "packExpiration": "Yeroon Paakkii Dhuma",
      "drugId": "ID qoricha sammuu hadoochu",
      "drugName": "Maqaa Qoricha",
      "drugGenericname": "Maqaa Qoricha Jeneerikiin",
      "drugManufacturer": "Oomisha Qorichaa",
      "distributorName": "Maqaa Raabsaa",
      "drugRegistrationdate": "Guyyaa Galmee Qorichaa",
      "nextDrug": "Itti Aanu Qoricha",
      "editDrug": "Qoricha Gulaali",
      "updateDrug": "Qoricha haaromsuu",
      "deleteDrug": "Qoricha Haquu",
      "noRecordfound": "Galmeen Hin Argamne",
      "addDrug": "Qoricha Dabalaa",
      "statementDrug": "Qorichi kun haqameera.  ",
      "cANCEL": "Haquu",
      "cONFIRM": "Mirkaneessuu",
      "sTATEMENT": "Galmee kana haquu akka barbaaddu mirkaneeffatteettaa?",
      "ok": " tole",
      "information": "Odeeffannoo",
      "packOrder": "Ajaja Paakkii",
      "packPrescription": "Ajaja yaalaa Paakkii",
      "packReservation": "Paakkii Reservation gochuu",
      "packLocation": "Bakka Paakkii",
      "drugDozedam": "Doosii Qorichaa guyyaa tokko keessatti Hidhaf",
      "drugDozecalf": "Doosii Qorichaa guyyaa tokkotti Re'eedhaaf",
      "drugFormate": "Akkaataa Qorichaa",
      "drugDistributor": "Raabsaa Qorichaa",
      "drugActiveingridents": "Wantoota Qoricha Socho'an",
      "drugSubstitutionId": "Bakka Bu'iinsa Qorichaa Id",
      "packId": "Pack Id",
      "packBatchNumber": "Lakkoofsa Tuuta Paakkii",
      "drugIdStatement": "Lakkoofsi batch qoricha kanaa.",
      "drugNameSatement": "Maqaa maqaa beeksifame kan qorichi kun ittiin gurguramu.",
      "drugGenericnameStatement": "Maqaa maqaa beeksifame qorichi itti gurguramu osoo hin taane keemikaala qoricha tokkoo.",
      "drugFormateSatement": "Lakkoofsi batch qoricha kanaa.",
      "drugDozecalfSatement": "Hamma doosiin qoricha gara re’ee beekuuf.",
      "drugDozedamStatement": "Hamma doosiin qoricha gara hidhaatti geessu beekuuf.",
      "drugManufacturerStatement": "Bal'ina oomishaa qorichaa.",
      "drugDistributorStatement": "Bal'ina raabsaa qoricha.",
      "drugRegistrationdateStatement": "Guyyaa galmee qoricha sammuu namaa hadoochu biyya murtaa’e keessatti.",
      "drugActiveingridentsStatement": "Tarree wantoota sochii qaban.",
      "drugSubstitutionIdStatement": "IDn bakka bu'iinsa qorichaaf ta'uu danda'u haala qorichi inni guddaan yeroo ammaa hin argamne keessatti.",
      "packIdStatement": "Bar code ykn RF ID paakkii sanaa.",
      "packBatchNumberStatement": "Lakkoofsa tuuta oomishtoonni paakkiidhaaf ramadaman.",
      "locationWarehouseID": "Bakka ID Kuusaa",
      "locationWarehouseIDState": "ID mana kuusaa bakka paakkii itti kuufame.",
      "locationRackID": "ID Raakkii Bakka",
      "locationRackIDStatement": "ID raakii bakka paakkii itti kuufame.",
      "locationTierID": "ID Sadarkaa Bakka",
      "locationTierIDStatement": "ID sadarkaa raakii irratti bakka paakkii itti kuufame.",
      "locationPositionID": "ID Bakka Bakka",
      "locationPositionIDStatement": "ID bakka sadarkaa paakkii itti kuufame irratti.",
      "storageTemperatureCondition": "Haala Ho’a Kuusaa",
      "storageTemperatureConditionStats": "Haala kuusaa paakkii.",
      "containerForm": "Unka Konteenara",
      "containerFormStatement": "Bifa meeshaa qorichi itti kuufame.",
      "consistQuantity": "Baay'ina of keessaa qabu",
      "consistQuantityStatement": "Baay’ina kiniinii, qaruuraa fi kkf paakkii keessa jiru.",
      "releaseId": "Id Gadhiisuu",
      "releaseIdStatement": "ID kan ramadame erga paakkii qonnaan bulaan fudhatame.",
      "releaseDate": "Guyyaa Gadhiifamuu",
      "releaseDateStatement": "Guyyaa yeroo paakkii qonnaan bulaan istookii irraa fudhatame.",
      "packManufacturedDate": "Paakkii oomishame Guyyaa",
      "packManufacturedDateStatement": "Guyyaa paakkii itti hojjetame.",
      "packImportedDate": "Guyyaa Paakkii Galfame",
      "packImportedDateStatement": "Guyyaa yeroo paakkii galfame.",
      "packExpirationDate": "Guyyaa Dhuma Paakkii",
      "packExpirationDateStatement": "Guyyaa yeroo paakkii yeroon itti darbe.",
      "expiredSoonFlag": "Yeroo Dhiyootti Dhufe Alaabaa",
      "expiredSoonFlagState": "Akeekkachiisa waa'ee paakkii yeroo dhiyootti akka dhumu.",
      "packTotalVolumeLeft": "Paakkii Waliigala Jildii Bitaa",
      "packTotalVolumeLeftState": "Lakkoofsa waliigalaa paakkii wantoota walfakkaatan qaban kanneen istookii keessatti hafan.",
      "packOrderID": "ID Ajaja Paakkii",
      "packOrderIDState": "ID kan erga paakkii raabsaa irraa ajajamee booda ramadame.",
      "packQuantityOrdered": "Baay'ina Paakkii Ajajame",
      "packQuantityOrderedState": "Baay'ina paakkii kan raabsaa irraa ajajame.",
      "packPrice": "Gatii Paakkii",
      "packPriceStatement": "Gatii paakkii.",
      "priceCurrency": "Maallaqa Gatii",
      "packPricecurrency": "Maallaqa Gatii Paakkii",
      "packPricecurrencyState": "Maqaa maallaqaa gatiin itti kaadhimame.",
      "packPaydate": "Guyyaa Kaffaltii Paakkii",
      "payDate": "Guyyaa Kaffaltii",
      "packPaydateState": "Guyyaa kaffaltiin raabsaaf gadhiifame.",
      "packShippingID": "ID Ergaa Paakkii",
      "shippingID": "ID Ergaa",
      "packShippingIdState": "Shipping id pack yeroo raabsaa irraa dhufu.",
      "packShippingDate": "Guyyaa Ergaa Paakkii",
      "shippingDate": "Guyyaa Ergaa",
      "packShippingDateState": "Guyyaa paakkii istookii sanatti gahu.",
      "packOrderStatus": "Haala Ajaja Paakkii",
      "packOrderStatusState": "Haala tartiiba amma jiruu.",
      "recepientKeeperId": "Id Eegduu Fudhataa",
      "recepientKeeperIdStatement": "Maqaa nama dhuunfaa/dhaabbata paakkii fudhate.",
      "recepientFarmId": "Id Qonnaa Fudhataa",
      "recepientFarmIdStatement": "ID qonna kan anilal drug recepint itti ta'e.",
      "recepientAnimalId": "Id Beeyladaa Fudhataa",
      "recepientAnimalIdState": "ID bineensa qorichi (paakkii) itti ajajame.",
      "specialistComments": "Yaada Ogeessotaa",
      "specialistCommentsState": "Yaada ogeessa/ogeessa beeyladaa waa’ee ajaja yaalaa.",
      "specialistName": "Maqaa Ogeessa",
      "specialistNameState": "Maqaa ogeessa/ogeessa beeyladaa qoricha kana ajaje.",
      "specialistID": "ID ogeessaa",
      "specialistIDState": "ID ogeessa/ogeessa beeyladaa qoricha ajaje.",
      "reservedByKeeperId": "Keeper Id tiin kan eegame",
      "reservedByKeeperIdState": "Keeper ID eenyu akka paakkii reserve godhe.",
      "reservedByFarmId": "Kan Eegame Farm Id",
      "reservedByFarmIdState": "ID qonnaa kan paakkii sana kan qabate.",
      "reservationTimeoutDate": "Guyyaa Yeroo Dhuma Reservation",
      "reservationTimeoutDateState": "Guyyaa yoo paakkii hin bitamne reservation ofumaan haqamu.",
      "reservationTimeout": "Yeroon Reservation Xumurame",
      "reservationTimeoutState": "Lakkoofsa sa’aatii booda yoo paakkii hin bitamne ykn hin fudhatamne reservation ofumaan haqamu",
      "reservationDate": "Guyyaa Reservation",
      "reservationDateState": "Guyyaa reservation paakkii sanaa.",
      "reservationStatus": "Haala Reservation",
      "reservationStatusState": "Haala reservation paakkii. ",
      "loadingDrugsPleaseWait": "Qoricha Fe'aa jira... Mee eegaa",
      "quantityOrder": "Tartiiba Baay’ina",
      "keeperID": "ID eegduu",
      "timeoutDate": "Guyyaa Yeroo Dhuma",
      "warehouseID": "ID mana kuusaa",
      "rackID": "ID Raakkii",
      "tierID": "ID sadarkaa",
      "positionID": "ID iddoo hojii",
      "temperatureCondition": "Haala Ho’aa",
      "manufactureDate": "Guyyaa Omishaa",
      "importedDate": "Guyyaa Galfame",
      "totalVolumeLeft": "Jildii Waliigalaa Hafe"
    },
    "reports": {
      "myReports": "Gabaasa Koo",
      "satelliteReports": "Gabaasa Saatalaayitii",
      "weatherReports": "Gabaasa Haala Qilleensaa",
      "pregnancyAnalytics": "Xiinxala Ulfaa",
      "semenEmbroyAnalytics": "Xiinxala Sanyii/Embroy",
      "semenAnalytics": "Xiinxala Sanyii Sanyii",
      "embryoAnalytics": "Xiinxala Miciree",
      "calfAnalytics": "Xiinxala Re'ee",
      "milkProduction": "Omisha Aannani",
      "totalMilkType": "Gosa Aannani Waliigalaa",
      "totalAnimalAnalytics": "Xiinxala Beeyladaa Waliigalaa",
      "animalAnalytics": "Xiinxala Beeyladaa",
      "analyticsAndReporting": "Xiinxala fi Gabaasa",
      "filterByCountry": "Filter Biyyaadhaan",
      "filterByFarm": "Filter Qonnaan",
      "filterByRegion": "Naannoodhaan Filter",
      "filterByMonth": "Ji'aan Filter",
      "filterByDate": "Guyyaadhaan Filter",
      "filterByRole": "Gaheedhaan Filter",
      "filterByYear": "Waggaadhaan Filter",
      "filterByTrait": "Amalaan Calaluu",
      "avgBreedingValue": "Gatii Walhormaataa Giddugaleessaa",
      "avgEconomicIndex": "Indeeksii Diinagdee Giddugaleessaa",
      "breederReport": "Gabaasa Horsiisaa",
      "semenTransferDate": "Guyyaa Dabarsa Sanyii",
      "semenEmbryoProductionReport": "Gabaasa Omisha Sanyii/Miciree",
      "semenProducts": "Oomishaalee Sanyii dhiiraa",
      "meatProducts": "Oomisha Foonii",
      "totalProducts": "Oomisha Waliigalaa",
      "semenEmbryoReport": "Gabaasa Sanyii/Miciree",
      "numOfStraws": "Lakkoofsa Qaccee",
      "collectionDate": "Guyyaa Walitti qabama",
      "productionReport": "Gabaasa Omishaa",
      "receipientId": "ID fudhataa",
      "embryoId": "ID miciree",
      "semenStrawId": "ID Qorqorroo Sanyii",
      "dataScientist": "Saayintistii Daataa",
      "dataScientistReport": "Gabaasa Saayintistii Daataa",
      "productReport": "Gabaasa Omishaa",
      "dairyProducts": "Oomishaalee Aannani"
    },
    "genoPerformance": {
      "performanceOfGenoType": "Raawwii Hojii GenoType",
      "addAGenoType": "GenoType tokko itti dabali",
      "breedName": "Maqaa Sanyii",
      "chromosome": "Kiroomozoomii",
      "sequenceChange": "Jijjiirama Tartiiba",
      "inheritance": "Dhaala",
      "diseaseName": "Maqaa Dhukkubaa",
      "referenceSequence": "Tartiiba Wabii",
      "pubmedReference": "Wabii Pubmed",
      "genoTypeRegistration": "Galmee Gosa Jeenoo",
      "breed": "Horsiisuu",
      "editAGenoType": "Gosa Jeenoo Gulaali",
      "editGenoType": "GenoType Gulaali",
      "loadingGene": "Loading Geno... Mee eegaa",
      "geneTypeList": "Tarree Gosa Jeenoo"
    },
    "reportings": {
      "conception": "Ulfa(Saayintistii Daataa) .",
      "performanceOfGenoData": "Raawwii Hojii Jeenootaayipii(Saayintistii Daataa) .",
      "totalInsemination": "Walumaagalatti Insemination",
      "embryo": "Miciree",
      "animalVaccinationRecord": "Galmee Talaallii Beeyladaa",
      "dataNotAvailable": "Daataan Qonna kanaaf Hin argamu.",
      "pregnancyStatus": "Haala Ulfaa",
      "healthReport": "Gabaasa Fayyaa",
      "heavyMilk": "Aannani Ulfaataa",
      "standardMilk": "Aannani Istaandardii"
    },
    "sidebar": {
      "healthAnalytics": "Xiinxala Fayyaa",
      "productionAnalytics": "Xiinxala Omishaa"
    },
    "epd": {
      "regNo": "Animal Reg No koodii addaa mala mallattoo fayyadamuun bineensotaaf kennamu yoo ta’u, adeemsa bineensota addaa adda baasuu fi hordofuuf hojjetame mirkaneessuudha",
      "internationalID": "ID Idil-addunyaa Beeyladaa",
      "location": "Biyya / Naannoo Dhaloota Beeyladaa ",
      "animalName": "Maqaa Istaandardii / Maqaa Bineensichaa",
      "gender": "Saala bineensichaa (dhiira/dubartii) .",
      "additionalIDMethod": "Bineensicha adda baasuuf mala akkamii fayyadame (fkn.ear tag, tattoo) .",
      "damID": "ID ykn Lakkoofsa galmee hidha beeyladaa-warra dubartii bineensa tokkoo/ID of Lakkoofsa haadha dhalootaa",
      "sireId": "Lakkoofsa eenyummaa ykn Galmee warra dhiiraa bineensa tokkoo, keessattuu re’ee hormaaf qabame ykn sanyii re’ee Insemination Namtolcheedhaaf oolu.",
      "dateOfBirth": "Guyyaa dhaloota bineensichaa.",
      "breederHerdCode": "Koodii Tuuta Horsiisaa irra caalaa Waldaalee Horsiistootaatiin kennama",
      "seasonofBirth": "Yeroo Dhaloota Beeyladaa ji'a ji'aan galmaa'e",
      "birthYear": "Bara bineensi dhalate",
      "birthManagementCode": "Koodii Bulchiinsa Dhalootaa irra caalaa fayyadamaa/qonnaan bulaatiin kan kennamu",
      "birthSex": "Saala bineensichaa (dhiira/dubartii) .",
      "birthWeight": "Ulfaatina Dhalootaa Re'ee ",
      "primaryBreed": "Major % Gumaacha jeneetikii bineensichaa ",
      "secondaryBreed": "Minor % Gumaacha jeneetikii bineensichaa ",
      "breedComposition": "Dhibbeentaan walnyaatinsa sanyii jechuun bakka bu’iinsa pirooppoorshinaalii sanyiiwwan adda addaa kan jeneetikii bineensa dhuunfaa ykn garee bineensotaa keessatti argamu agarsiisa. ",
      "conceptionMethod": "Akkaataa bineensichi itti ulfoofte (walhormaata uumamaa/ walhormaata/dabarsuu miciree).",
      "accuracyWeight": "Ulfaatina Sirrummaa",
      "damAge": "Umriin hidhichaa ji’oota/waggaan fkn. ",
      "weaningWeight": "Harma irraa kutuu Ulfaatina bineensi yeroo harma irraa kutuu.",
      "weaningDate": "Guyyaa bineensi harma irraa cite",
      "weaningSex": "Saala bineensa harma irraa cite. ",
      "managementPastureCode": "Koodii fayyadamaa/ qonnaan bulaan bulchiinsa/ dheedichaaf kenname ",
      "creep": "Nyaachisuun (creep feeding) jechuun gocha nyaata dabalataa (midhaan ykn dheedhii) re’oota hoosisaniif kennuudha.",
      "weaningContemporaryGroupCode": "Seera Ulfaatina Harma Hiikuu Garee Yeroo Ammaa",
      "birthContemporaryCode": "Dhaloota Seera Yeroo",
      "yearlingDate": "Guyyaa bineensi waggaa tokko yookiin waggaa lammaffaa umriin isaa",
      "managementFeedUnitCode": "Koodii fayyadamaan kutaa bulchiinsa/ nyaataaf kenname",
      "yearlingSex": "Saala bineensichaa yeroo waggaa ",
      "yearlingWeight": "Ulfaatinni Waggaa safartuu guddina kallattiin harma irraa ciccituu boodaa yoo ta’u yeroo baay’ee raawwii dandeettii sanyii gabaatti hidhamee bakka nyaataa keessatti calaqqisiisuuf kan gargaaru yoo ta’u, paawundii re’een safarama.",
      "yearlingHeight": "Olka’iinsa bineensichaa yeroo waggaa waggaa ",
      "yearlingWeightContemporaryGroupCode": "Koodii Ulfaatina Waggaa Garee Yeroo Ammaa",
      "weaningYearlingWeightContemporaryGroupCode": "koodii Harma Hiikuu ykn Ulfaatina Waggaa Garee Yeroo Ammaa",
      "daysOnFeed": "Baay’ina guyyoota nyaata addaa sanaan nyaataman Fkn: loon xixiqqoo guddachaa jiran nyaata anniisaa guddaa qabu nyaachisuun foon loonii gabaadhaaf dhiyaatu baasii xiqqaadhaan bu’aa argatu. ",
      "managementFeedUnitPenCode": "Koodii fayyadamaan bulchiinsa/ yuunitii nyaataa/qalamaaf kenname",
      "harvestDate": "Guyyaa horiin foon itti qalame ( ajjeefamee )",
      "gradingDate": "Guyyaan reeffaa akkaataa ulaagaa addaatiin sadarkaa kennameera",
      "carcassSex": "Saala reeffaa",
      "dateonFeed": "Guyyaa bineensichi gara nyaata haaraatti itti ce’e Fkn: loon xixiqqoo guddachaa jiran nyaata anniisaa guddaa qabu nyaachisuun foon loonii gabaaf dhiyaatu baasii xiqqaadhaan bu’aa argatu. ",
      "KPH": "% KPH jechuun cooma waliigalaa qaawwa qaama reeffaa addatti naannoo tiruu, qaama saalaa fi onnee keessatti argamu keessaa dhibbeentaadha. ",
      "carcassWeight": "Ulfaatina reeffa jechuun gogaa, mataa, ujummoo garaachaa fi qaamolee keessaa erga sassaabamee fi baafamee booda ulfaatina ho’aa ykn hin qabbanaa’in. ",
      "fatThickness": "Fulbaanni coomaa safarama inchiitiin sarara xiqqaa fayyadamuun. ",
      "marbling": "Marbling cooma maashaa keessaa kan hin guutamne (fayyaa) kan mul’atu kan maashaa keessaa fi baandaa fiber maashaa gidduutti kuufamuudha.",
      "ribeyeArea": "Hammi bal’ina rib-eye (loin ykn ribeye muscle longissimus dorsi) rib 12ffaa fi 13ffaa gidduutti inchii iskuweeriin giiridii fayyadamuun safarame (fkn, inchii 8, 9 ykn 10). ",
      "animalStatus": "Haala beeyladaa qonna keessatti argamu fkn: fayyaa, dhukkubsataa fi kkf"
    },
    "manageAnimalGroupings": {
      "resetModeTooltip": "\n        HAALA RESET GOCHUU <br>\n            Haala kanaan <br>\n            1) Amaloota fedhii hundaaf amala gareewwan yeroo (CG) hunda kaa’uu/hiikuu. <br>\n            2) Bineensota hunda CG walgitutti ramaduu. <br>\n            3) Yoo ramaddiin bineensotaa quubsaa hin taane, CG sirreessuu/jijjiiri, achiis ammas bineensota gara CG haaraa walgitutti ramadi. <br>\n            4) Tarkaanfiiwwan armaan olii irra deebi’i, yoo barbaachisaa ta’e, hanga CGwwan fi garee/ramaddii bineensotaa wal-simutti quufanitti.<br>\n        ",
      "maintainanceModeHeadingTooltip": "Erga RESET (haalli) xumuramee booda, MAINTENANCE MODE seenta bakka EDPn RESET irratti shallagaman tokkoon tokkoon bineensaaf hanga RESET itti aanutti (kun ji'a 2-6 hafuu danda'a) dhaabbataa ta'ee eegamu. ",
      "maintainanceModeTooltip": "Erga RESET MODE xumurtee booda, RESET FINALIZED button dhiibaa sirnichi EPD bineensota hunda akka shallagu, Terminate the RESET MODE, fi MAINTENANCE MODE akka jalqabu dandeessisa.",
      "resetToggleTooltip": "Bineensota gara CGtti ramaduuf qindaa'ina moodeela EPD keessatti Jijjiirama Irradeebi'uu dandeessisi."
    },
    "geneticsAndBreeding": {
      "geneticsAndBreeding": "Jeneetiksii",
      "geneticSearchTool": "Meeshaa Barbaacha Jeneetikii",
      "dataSubmission": "Daataa Dhiyeessuu / Filannoo Beeyladaa",
      "animalsWithExpectedProgenyDifferences": "Filannoo Beeyladaa Shallaggii Garaagarummaa Sanyii Eegamuu (EPDs).",
      "searchByAnimalIdName": "Id Beeyladaa, Maqaadhaan barbaadi",
      "rowsPerPage": "Tarreewwan fuula tokko irratti",
      "individualEntry": "Galmee Dhuunfaa",
      "bulkEntry": "Galmee Jumlaa",
      "registerANewAnimalOrSelectAnExistingAnimal": "Bineensa haaraa galmeessi ykn bineensa jiru filadhu.",
      "registerNewAnimal": "Galmeessaa Beeylada Haaraa",
      "selectExistingAnimal": "Bineensa Jiru Filadhu",
      "animalID": "ID bineensotaa",
      "animalName": "Maqaa Beeyladaa",
      "tag": "Adda baasuuf mallattoo wayitti maxxanfamu",
      "dateOfBirth": "Guyyaa Dhalootaa",
      "gender": "Koorniyaa",
      "birthDate": "Guyyaa Dhalootaa",
      "birthWeightLb": "Ulfaatina Dhalootaa (lb) .",
      "birthWeightKg": "Ulfaatina Dhalootaa(kg) .",
      "weaningWeightLb": "Ulfaatina harma irraa kutuu (lb) .",
      "weaningWeightKg": "Ulfaatina harma irraa kutuu(kg) .",
      "yearlingWeightLb": "Ulfaatina Waggaa (lb) .",
      "yearlingWeightKg": "Ulfaatina Waggaa(kg) .",
      "carcassWeightLb": "Ulfaatina reeffa (lb) .",
      "carcassWeightKg": "Ulfaatina reeffa(kg) .",
      "animalSelection": "Filannoo Beeyladaa",
      "animalSearchTool": "Meeshaa Barbaacha Beeyladaa",
      "back": "Dugda",
      "searchByEPDs": "EPDn barbaadi",
      "searchByIds": "Ids tiin barbaadi",
      "selectBreed": "Sanyii filadhu",
      "selectGender": "Saala filadhu",
      "selectRequiredBreedForCattle": "Looniif Sanyii Barbaachisu Filadhu",
      "resetFilter": "FILTER RESET GOCHUU",
      "birthWeightHeader": "Ulfaatina Dhalootaa(BW): . ",
      "birthWeightDef": "Garaagarummaa ulfaatina re’ee yeroo dhalatan walbira qabuu fi paawundii ykn kg tiin kan safaramu dha.",
      "weaningWeightHeader": "Ulfaatina Harma Hiikuu(WW): . ",
      "weaningWeightDef": "WW EPD tilmaama guddina harma irraa cituu duraa kan paawundii ykn kg tiin safaramudha.",
      "yearlingWeightHeader": "Ulfaatina Waggaa(YW): . ",
      "yearlingWeightDef": "YW EPD tilmaama guddina harma irraa cituu boodaa kan paawundii ykn kg tiin safaramudha.",
      "ribEyeAreaHeader": "Naannoo Ribeye(REA): . ",
      "ribEyeAreaDef": "REA guddina maashaa ribeye nuuf kennu iskuweer inchiitiin safara.REA EPDn garaagarummaa safartuu naannoo ribeye guyyoota 365 sirreeffame kan safartuu reeffa loon sassaabaman irratti hundaa’e calaqqisiisu.",
      "marblingHeader": "Marbling(MARB): 1. . ",
      "marblingDef": "MARB EPDn yuunitii dhibbeentaa cooma maashaa keessaa ribeye keessa jiruun argama.MARB EPDn garaagarummaa qabxii marbling guyyoota 365 sirreeffame (copha maashaa keessaa, [IMF]) safartuu reeffa loon sassaabaman irratti hundaa’e calaqqisiisu.",
      "fatThicknessHeader": "Fulbaana Coomaa(FAT): . ",
      "fatThicknessDef": "Inchii cooma dugda (inchii dhibba keessaa) yuunitii safartuu FT ti.",
      "carcassWeightHeader": "Ulfaatina reeffa(CW): . ",
      "carcassWeightDef": "Ulfaatinni reeffaa dhiibbaa paawundii gatii oomisha dhumaa wajjin walqabatee qabu yeroo ilaallu amala faayidaa qabuudha. ",
      "yieldGradeHeader": "Sadarkaa Omishaa(YG): . ",
      "yieldGradeDef": "Sirni qabxii sadarkaa Omishaa USDA yuunitii safartuu YG EPD ti. ",
      "milkHeader": "Aannani(MK): . ",
      "milkDef": "MK EPDn sababa dandeettii aannan haati isaa irraa kan ka’e ulfaatina re’ee harma irraa kutuu paawundiin safarama.",
      "totalMaternalHeader": "Waliigala Haadha(TM): . ",
      "totalMaternalDef": "TM sababa oomisha aannanii fi jeneetikii re’ee guddinaaf qabu irraa kan ka’e ulfaatina re’ee harma irraa kutuu irratti dhiibbaa safara.",
      "calvingEaseDirectHeader": "Salphaa Da'umsaa Kallatti(CED): . ",
      "calvingEaseDirectDef": "CED EPDn akka dhibbeentaa ilmoolee gargaarsa hin qabneetti tarreeffameera.",
      "calvingEaseMaternalHeader": "Da'umsa Salphaa Haadha(CEM): . ",
      "calvingEaseMaternalDef": "Dandeettii ijoolleen durbaa re’ee akka daa’imman waggaa lamaatti gargaarsa malee ilmoo horachuu ni madaala.",
      "stayabilityHeader": "Turtii(STAY): . ",
      "stayabilityDef": "ST EPD dandeettii re’een tokko re’oota “naannoo hafan” horachuu danda’u tilmaama. ",
      "docilityHeader": "Docility(DOC): 1. . ",
      "docilityDef": "DOCn miira loon safara.",
      "max": "MAX",
      "min": "MIN",
      "accuracy": "DOGOGGORAALA",
      "sortBy": "Akkaataa Sort By",
      "traits": "Amaloonni halluu diimaatiin agarsiifaman misoomarra jiru, Q2, 2023 keessa dhufa.",
      "searchResults": "Bu'aa Barbaacha",
      "recordsFound": "galmeewwan argaman",
      "compareSelected": "WALDAALA FILATAME",
      "animalIdentification": "Eenyummaa Beeyladaa",
      "errorMessage": {
        "birthWeight": "Gatiin guddaan ulfaatina dhalootaa Ulfaatina dhalootaa xiqqaa gadi ta’uu hin danda’u",
        "weaningWeight": "Gatiin ol’aanaa ulfaatina harma irraa kutuu xiqqaa ulfaatina harma irraa kutuu gadi ta’uu hin danda’u",
        "yearlingWeight": "Gatiin guddaan ulfaatina waggaa xiqqaa ulfaatina waggaa gadi ta’uu hin danda’u",
        "carcassWeight": "Gatiin guddaan ulfaatina reeffaa Ulfaatina dhalootaa xiqqaa gadi ta’uu hin danda’u",
        "fatThickness": "Gatiin guddaan Fulbaana Coomaa Ulfaatina harma irraa hir’isuu xiqqaa gadi ta’uu hin danda’u",
        "marbling": "Gatiin guddaan marbling ulfaatina waggaa xiqqaa gadi ta’uu hin danda’u",
        "ribeyeArea": "Gatiin guddaan Naannoo Ribeye Ulfaatina dhalootaa xiqqaa gadi ta’uu hin danda’u",
        "yieldGrade": "Gatiin ol’aanaa Sadarkaa Omishaa Ulfaatina harma irraa hir’isuu xiqqaa gadi ta’uu hin danda’u",
        "milk": "Gatiin guddaan aannan ulfaatina harma irraa hir’isuu xiqqaa gadi ta’uu hin danda’u"
      },
      "reg": "Reg",
      "name": "Maqaa",
      "sex": "Walqunnamtii saalaa",
      "tattoo": "Tattoo",
      "dob": "DOB",
      "EPD": "EPD",
      "rank": "Sadarkaa",
      "searchValue": "Gatii Barbaadi",
      "typeHere": "Asirratti barreessi",
      "searching": "Barbaacha...",
      "fetchingResult": "Bu'aa fidaa jira...Mee eegaa",
      "animalsMatchedYourCriteria": "Bineensonni Ulaagaa Keessan Walsimsiisan",
      "manageAnimalsGrouping": "Garee Beeyladaa Bulchuu",
      "manageAnimalGroupings": "Garee Beeyladaa Bulchuu",
      "assignAnimalToContemporaryGroups": "Beeylada Garee Yeroo Ammaatti Ramaduu",
      "resetMode": "Haalata Irra Deebiin Saagi",
      "enterResetMode": "Haalata Irra Deebi'i Saagi",
      "maintainanceMode": "Haala Suphaa",
      "assigningAnimals": "Beeylada Ramaduu",
      "excludedAnimals": "Bineensota Ala Ta'an",
      "ungroupedAnimals": "Bineensota Garee Hin Qabne",
      "assignAnimalsToCGS": "Beeylada CGStti Ramaduu",
      "reset": "Reset gochuu",
      "excludeAnimals": "Beeylada keessaa baasuu",
      "resetToMaintainanceMode": "Reset Finalized - Gara Haalata Suphaatti Jijjiirraa",
      "contemporaryGroupsSettings": "Gareewwan Yeroo Ammaa(CG) Settings",
      "selectTrait": "Amala filadhu",
      "selectTraitDescription": "Amala Filadhu adeemsa amala murtaa'e filachuu agarsiisa",
      "traitsType": {
        "birthWeight": "Ulfaatina Dhalootaa",
        "weaningWeight": "Ulfaatina Harma Hiikuu",
        "yearlingWeight": "Ulfaatina Waggaa",
        "carcassWeight": "Ulfaatina reeffaa"
      },
      "addNewGroup": "GAREE HAARAA DADDAAL",
      "contemporaryGroup": "Garee Yeroo Ammaa",
      "contemporaryGroups": "Gareewwan Yeroo Ammaa",
      "editGroup": "Garee Gulaali",
      "birthCGCode": "Koodii Dhaloota(CG).",
      "groupName": "Maqaa Garee",
      "birthSex": "Walqunnamtii Saalaa Dhalootaa",
      "conceptionMethod": "Mala Ulfa",
      "weaningCGCode": "Seera harma irraa kutuu(CG).",
      "yearlingCGCode": "Koodii Waggaa(CG).",
      "dateWeight": "Ulfaatina Guyyaa",
      "weaningyearlingCGcode": "Koodii Harma Hiikuu/Waggaa(CG).",
      "carcassCGCode": "Koodii reeffa(CG).",
      "breedOfDom": "Sanyii Hidha",
      "addNewContemporaryGroup": "Garee Yeroo Haaraa Dabaluu",
      "createNewGroup": "Garee Haaraa Uumuu",
      "selectFromDifferentTraits": "Amaloota adda addaa keessaa filadhu",
      "contemporaryGroupName": "Maqaa Garee Yeroo Ammaa",
      "enterNameHere": "Maqaa asitti galchi",
      "groupNameIsRequired": "Maqaa Garee barbaachisa",
      "birthYearRange": "Daangaa Waggaa Dhalootaa",
      "theYearAnimalWasBorn": "Waggaa bineensi dhalate",
      "birthYearIsRequired": "Bara Dhalootaa barbaachisa",
      "genderOfNewBornAnimal": "Saala bineensa reefuu dhalatee",
      "selectSex": "Walqunnamtii Saalaa Filadhu",
      "theweightOfAnimalAtBirth": "Ulfaatina bineensi yeroo dhalatu",
      "maximumKg": "Maximum",
      "minimumKg": "Xiqqaa",
      "aSeasonisAPeriodOfYear": "Yeroon yeroo waggaa haala qilleensaa adda ta’een adda ta’eedha.",
      "seasonofBirthIsRequired": "Yeroon Dhalootaa barbaachisaadha",
      "majorGenericContributionOfAnimal": "Gumaa % Guddaa Gumaacha Waliigalaa Beeyladaa",
      "primaryBreedCompostionIsRequired": "Qabiyyee Sanyii Duraa barbaachisa",
      "secondaryBreedCompostionIsRequired": "Qabiyyee Sanyii Lammaffaa barbaachisa",
      "howTheAnimalWasConceived": "Akkaataa bineensichi itti ulfaate (walhormaata uumamaa/insemination/dabarsuu miciree) .",
      "conceptionMethodIsRequired": "Mala Ulfa (Ulfa Method) barbaachisa",
      "epdModelSettings": "Sajoo Moodeela EPD",
      "forResetMode": "Haalata Irra Deebi'uuf",
      "progenyWeightingFactor": "Qabxii Ulfaatina Sanyii",
      "weightGivenToTheProgenyFactor": "Ulfaatina haala Reset keessatti shallaggii EPD tiif factor CG factor wajjin walqabatee factor sanyii kenname. ",
      "enterNumber": "Lakkoofsa galchi",
      "enterBreed": "Sanyii galchaa",
      "valueShouldBeBetween0and1": "Gatiin 0 fi 1 gidduutti ta'uu qaba",
      "resetDuration": "Turtii Irra Deebi'i",
      "timeIntervalBetweenLastAndFirstResetMode": "Yeroo haalata deebisanii dhaabuu isa dhumaa fi haaraa gidduu jiru, dhuma isaa irratti haalata deebisanii dhaabuu haaraan dandeessifamee fi CG fi EPD haaraa shallagamu.",
      "enterNumberOfDays": "Lakkoofsa Guyyootaa Galchi",
      "valueCannotBeNegative": "Gatiin negaatiivii ta'uu hin danda'u!",
      "criticalProgenyPopulation": "Uummata Sanyii Murteessaa",
      "minimumNumberOfProgenyRecords": "Lakkoofsi galmee sanyii xiqqaa bineensa dhuunfaa sirna keessatti Sirrummaa Sanyii (APD1) galmaan ga’uuf barbaachisaa ta’e %50 ol (Sirrummaa Sanyiitiif) .",
      "criticalAncestorPopulation": "Uummata Akaakayyuu Murteessaa",
      "minimumNumberOfAncestorsRecords": "Galmee abbootii xiqqaa bineensa dhuunfaa sirna keessatti Sirrummaa Abbootii (APD4) galmaan ga’uuf barbaachisaa ta’e %50 ol (Sirrummaa Sanyiitiif) .",
      "forBirthWeightCG": "Ulfaatina Dhalootaa CG",
      "criticalPopulationInAnimalsContemporaryGroup": "Uummata Murteessaa Garee Yeroo Beeyladaa Keessatti",
      "minimumAverageNumberOfAnimalsPerBirthWeight": "Giddugaleessa lakkoofsa bineensotaa xiqqaan ulfaatina Dhalootaa tokkoof CG barbaachisaa ta’e Giddugaleessa Sirrummaa CG (ACG3) %50 ol galmaan ga’uuf .",
      "criticalAveragePopulationPerContemporaryGroup": "Giddugaleessa Uummata Murteessaa Garee Yeroo Tokkoof",
      "minimumNumberOfAnimalsInBirthWeight": "Lakkoofsi bineensotaa xiqqaan Ulfaatina Dhalootaa bineensichaa keessatti CG Sirrummaa CG (ACG2) %50 ol galmaan ga’uuf barbaachisaa ta’e .",
      "forWeaningWeightCG": "Ulfaatina Harma Hiikuu CG",
      "minimumAverageNumberOfAnimalsPerWeaningWeight": "Giddugaleessa baay’ina bineensotaa xiqqaan ulfaatina harma irraa kutuu CG tokkoof barbaachisaa ta’e Giddugaleessa Sirrummaa CG (ACG3) %50 ol galmaan ga’uuf .",
      "minimumNumberOfAnimalsInWeaningWeight": "Lakkoofsi bineensotaa xiqqaan Ulfaatina harma irraa cituu CG bineensichaa keessatti Sirrummaa CG (ACG2) %50 ol galmaan ga’uuf barbaachisaa ta’e .",
      "forYearlingWeightCG": "Ulfaatina Waggaa CG",
      "minimumAverageNumberOfAnimalsPerYearling": "Giddugaleessaan lakkoofsa bineensotaa xiqqaan CG Waggaa tokkoof barbaachisaa ta’e Giddugaleessa Sirrummaa CG (ACG3) %50 ol galmaan ga’uuf .",
      "minimumNumberOfAnimalsInYearlingWeight": "Lakkoofsi bineensotaa xiqqaan Ulfaatina Waggaa bineensichaa keessatti CG Sirrummaa CG (ACG2) %50 ol galmaan ga’uuf barbaachisaa ta’e .",
      "forCarcassCG": "Carcass CG tiif",
      "minimumAverageNumberOfAnimalsPerCarcassWeight": "Giddugaleessa lakkoofsa bineensotaa xiqqaan ulfaatina reeffaa CG tokkoof barbaachisaa ta’e Giddugaleessa Sirrummaa CG (ACG3) %50 ol galmaan ga’uuf .",
      "minimumNumberOFAnimalInCarcassWeight": "Lakkoofsi bineensotaa xiqqaan ulfaatina Carcass bineensichaa keessatti CG Sirrummaa CG (ACG2) %50 ol galmaan ga’uuf barbaachisaa ta’e .",
      "epdRequiredFieldSettings": "EPD Sajoo Dirree Barbaachisu",
      "pleaseSelectRequiredFieldsForCompleteEPD": "Maaloo shallaggii EPD guutuuf man'eewwan barbaachisan filadhu",
      "byDefault": "Akka Durtiitti",
      "pleaseNoteThatUsersNotAbleToObtainFullEPD": "Hubachiisa: fayyadamtoonni yoo dirree deetaa akka barbaachisummaa isaatti mallatteessite hin kennine shallaggii EPD guutuu argachuu akka hin dandeenye hubadhu.",
      "pleaseNoteThatRequiredFieldParametersCannotBeChanged": "Hubachiisa: Maaloo hubadhu, gareewwan yeroo ammaa qajoojiiwwan duraanii irratti waan jiraniif, qajoojiiwwan dirree barbaachisoo ta'an jijjiiramuu hin danda'an.",
      "noResultFound": "BU'AAN HIN ARGAMNE",
      "next": "Kan itti aanu",
      "cancel": "Haquu",
      "selectAnimal": "Bineensa filadhu",
      "searchBy": "Search By",
      "breed": "Horsiisuu",
      "regDate": "Reg. ",
      "status": "Sadarkaa",
      "animalDetails": "Bal'ina Beeyladaa",
      "add": "Ida'uu",
      "update": "Odeeffannoo dhiyeenyaa",
      "dataForEPDs": " Daataa EPDf",
      "basicInformation": "Odeeffannoo Bu'uuraa",
      "birthWeightInformation": "Odeeffannoo Ulfaatina Dhalootaa",
      "weaningWeightInformation": "Odeeffannoo Ulfaatina Harma Hiikuu",
      "yearlingWeightInformation": "Odeeffannoo Ulfaatina Waggaa",
      "carcassWeightInformation": "Odeeffannoo Ulfaatina reeffaa",
      "delete": "Haquu",
      "deleteEpdData": "Daataa EPD haquu",
      "areYouSureYouWantToDeleteEpdData": "Deetaa EPD haquu akka barbaaddu mirkaneeffatteettaa.",
      "internationalID": "ID idil-addunyaa",
      "enterID": "ID galchi",
      "animalRegistration": "Galmee Beeyladaa",
      "location": "Bakka",
      "additionalIDMethod": "Mala ID Dabalataa",
      "damID": "ID Hidha",
      "sireID": "ID Abbaa",
      "breederHerdCode": "Seera Tuuta Horsiisaa",
      "birthYear": "Bara Dhalootaa",
      "primaryBreed": "Sanyii Duraa",
      "breedComposition": "Qabiyyee Sanyii",
      "secondaryBreed": "Sanyii Lammaffaa",
      "seasonofBirth": "Yeroo Dhalootaa",
      "birthManagementCode": "Seera Bulchiinsa Dhalootaa",
      "damAge": "Barbadaa'uu",
      "years": "Waggoota",
      "birthContemporaryCode": "Dhaloota Seera Yeroo",
      "accuracyWeight": "Ulfaatina Sirrummaa",
      "note": "Yaadannoo",
      "minimumRequiredFieldForBirthWeight": "Dirree xiqqaa barbaachisu EPD Ulfaatina Dhalootaa",
      "birthYearGenderConceptionMethodBirthWeight": "Bara Dhalootaa , Saala , Mala Ulfa , Ulfaatina Dhalootaa",
      "weaningWeight": "Ulfaatina Harma Hiikuu",
      "weaningDate": "Guyyaa Harma Ciisuu",
      "weaningContemporaryGroupCode": "Harma Hiikuu Koodii Garee Yeroo Ammaa",
      "creep": "Suuta ejjechuu",
      "managementPastureCode": "Seera Bulchiinsa/Dheedhii",
      "weaningSex": "Walqunnamtii Saalaa Harma irraa Hiikuu",
      "minimumRequiredFieldForWeaningWeight": "Dirree xiqqaa barbaachisu EPD Ulfaatina Harma Hiikuu",
      "weaningWeightManagementPastureCodeWeaningSexDateWeighed": "Ulfaatina Harma Hiikuu , Koodii Bulchiinsa/Dheenya , Walqunnamtii Saalaa Harma Hiikuu , Guyyaa Ulfaatina",
      "yearlingWeight": "Ulfaatina Waggaa",
      "yearlingHeight": "Dheerinni Waggaa",
      "yearlingDate": "Guyyaa Waggaa",
      "yearlingContemporaryGroupCode": "Koodii Garee Yeroo Waggaa",
      "managementFeedingCode": "Seera Bulchiinsa/Nyaata",
      "yearlingSex": "Walqunnamtii Saalaa Waggaa",
      "youWillNeedToFillOutFor": "Dirreewwan hunda deetaa EPD argachuuf guutuu si barbaachisa",
      "pleaseSelectHavestDateFirstToEnterInfo": "Mee jalqaba 'Harvest Date' filadhaa info for Rib Eye Area,Fat Thickness fi Marbling galchuuf",
      "harvestDate": "Guyyaa Sassaabbii",
      "dateOnFeed": "Guyyaa Nyaata Irratti",
      "daysOnFeed": "Guyyoota Nyaata Irratti",
      "gradingDate": "Guyyaa Sadarkaa Kennuu",
      "carcassSex": "Walqunnamtii Saalaa Reeffa",
      "carcassWeight": "Ulfaatina reeffaa",
      "carcassContemporary": "Carcass Yeroo Ammaa",
      "damBreed": "Sanyii Hidha",
      "ribEyeArea": "Naannoo Ija Lafee Dugdaa",
      "ribEyeAreaContemporary": "Naannoo Ija Rib Kan Yeroo Ammaa",
      "fatThickness": "Fulbaana Cophaa",
      "fatThicknessContemporary": "Fulbaanni Cooma Yeroo Ammaa",
      "marbling": "Marbling jedhamuun beekama",
      "marblingContemporary": "Marbling Kan Yeroo Ammaa",
      "yieldGradeContemporary": "Sadarkaa Omishaa Yeroo Ammaa",
      "animalsNotListedInContemporaryGroupsMsg": "Bineensonni sababa odeeffannoo dhabamaniin garee yeroo ammaa kamittuu hin dabalamne. ",
      "listOfUngroupedAnimals": "Tarree Bineensota Garee Hin Qabne",
      "submittingData": "Daataa Galchuu",
      "resendToUser": "Fayyadamaa Irra Deebiin Ergaa",
      "submittingAnimalsInGroupMsg": "Beeylada keessan gareedhaan galchuu. ",
      "pressingResetBtnMsg": "Qabduu \"Reset\" dhiibuun adeemsa bineensota garee yeroo isaaniitti irra deebi'anii ramaduu ni jalqaba.",
      "doYouWantToProceed": "Itti fufuu barbaadduu ?",
      "systemMaintainanceModeMsg": "Qabduu \"Change to Maintenance Mode\" jedhu dhiibuun adeemsa tokko kan jalqabu yoo ta'u sirni keessan gara “MAINTENANCE MODE” kan seenu yoo ta'u, EDPn RESET irratti shallagame tokkoon tokkoon bineensaaf hanga RESET itti aanutti (kun ji'a 1-6 ta'uu danda'a) dhaabbataa ta'a ",
      "errorFetchingContemporaryGrpMsg": "Dogoggora deetaa garee yeroo ammaa fiduu",
      "deleteSuccess": "Milkaa'ina Haquu",
      "deleteSuccessMsg": "Gareen yeroo ammaa milkaa'inaan haqame.",
      "deleteFailed": "Haquun Hin milkoofne",
      "deleteFailedMsg": "Dogoggora deetaa garee yeroo ammaa haquu",
      "deleteContemporaryGrpMsg": "Garee yeroo ammaa kana haquu akka barbaaddu mirkaneeffatteettaa?",
      "addBirthWeightData": "Daataa Ulfaatina Dhalootaa Dabaluu",
      "addWeaningWeightData": "Daataa Ulfaatina Harma Hiikuu Dabalaa",
      "birthWeightContemporaryGroupCode": "Ulfaatina Dhalootaa Koodii Garee Yeroo Ammaa",
      "dateWeighted": "Guyyaa Ulfaatina",
      "addYearlingWeightData": "Daataa Ulfaatina Waggaa Dabalaa",
      "addCarcassWeightData": "Daataa Ulfaatina Reeffa Dabalaa",
      "weaningOrYearlingContemporaryGroupCode": "Harma Hiikuu ykn Ulfaatina Waggaa Koodii Garee Yeroo Ammaa",
      "deleteContemporaryGroupMsg": "Garee yeroo ammaa kana haquu akka barbaaddu mirkaneeffatteettaa?",
      "updateSuccessMsg": "Gareen yeroo ammaa milkaa'inaan haaromfame.",
      "errorMsg": "Waan tokkotu dogoggora ta'e. ",
      "fetchErrorMsg": "Dogoggora man'eelee barbaachisoo amala filatameef fiduu.",
      "forMaintainanceMode": "Haala Suphaaf",
      "ancestorsWeightFactor": "Qabxii Ulfaatina Abbootii",
      "weightGivenToTheAncestorFactor": "Ulfaatina haala Suphaa keessatti shallaggii EPD tiif CG factor wajjin walqabatee factor ancestor factor kenname. ",
      "addEPDModelSettingsData": "Deetaa Sajoo Moodeela EPD Dabaluu",
      "minimumNumberOfAnimalsInContemporaryGroups": "Lakkoofsa Bineensota Garee Yeroo Keessatti Xiqqaa",
      "enterNumberOfAnimals": "Lakkoofsa Bineensota Galchi",
      "areYouSureYouWantToChangeEPDCalculation": "Dirreewwan shallaggii EPD barbaachisan jijjiiruu akka barbaaddu mirkaneeffatteettaa?",
      "weightOfAnimalAtBirth": "Ulfaatina Beeyladaa yeroo Dhaloota",
      "seasonIsAPeriodOfYear": "Waqtiin jechuun yeroo waggaa haala qilleensaa adda ta’een adda ta’eedha.",
      "codeOfBirthWeightContemporaryGroup": "Koodii Ulfaatina Dhalootaa Garee Yeroo Ammaa",
      "weaningWeightOfCalf": "Ulfaatina Harma Hiikuu Re'ee",
      "dateAnimalWasWeaned": "Guyyaa bineensichi harma irraa cite",
      "genderOfWeaningAnimal": "Saala Beeylada Harma irraa Cituu",
      "yearlingWeightOfCalf": "Ulfaatina Waggaa Re'ee",
      "dateAnimalWasWeighted": "Guyyaa bineensichi itti ulfaate",
      "yearledAnimalSex": "Saala bineensa waggaa ture",
      "dateOfAnimalKilledForMeat": "Guyyaa bineensi fooniif ajjeefame",
      "addSuccessMsg": "Gareen yeroo ammaa milkaa'inaan dabale",
      "traitH": "Amala shallaggii EPD tiif.",
      "searchByValue": "Lakk Galmee/Tattoo/Maqaa/Tag galchi"
    }
  }